import './index.css';
import './index.scss'; 

import * as THREE from 'three';

//import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';

import {TweenMax, gsap} from 'gsap';
// import {SplitText} from 'gsap/src/SplitText';

import { Power2, Bounce, Elastic } from 'gsap/gsap-core';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import { Object3D, Vector3, MathUtils } from 'three';

// gsap.registerPlugin(SplitText);

var container;
var renderer;
var transition;
var languageSelected = 0;

var transitionParams = {
	"useTexture": true,
	"transition": 0.5,
	"transitionSpeed": 2.0,
	"texture": 5,
	"loopTexture": true,
	"animateTransition": true,
	"textureThreshold": 0.3
};

var clock = new THREE.Clock();
var sceneCityCamera = [];
var sceneCityInfoCamera = [];

var loadingTag = document.getElementById("loadingScreen");
loadingTag.style.display = 'block';

var aspectTag = document.getElementById("aspectOverlay");
aspectTag.style.display = 'none';

var zoneHeading = document.getElementById("zoneHeading");
zoneHeading.style.display = 'none';

var zonePanel = document.getElementById("zoneInfo");
zonePanel.style.display = 'none';

var zoneTitle = document.getElementById("zoneTitle");
zoneTitle.style.display = 'none';

var rotateDiv = document.getElementById("rotateDiv");
rotateDiv.style.display = 'none';

var zoneName = document.getElementById("zoneName");

zoneName.style.fontFamily = 'AlmaraiBold';

// document.getElementById("shareOnWhatsApp").addEventListener('click', function() {
//   //var hastag = "اليوم_الوطني_السعودي_90#";
//   var message = "Happy National Day! #SaudiNationalDay%0a%0aAn Experience designed and developed by Midwam%0ahttps://www.midwam.com";
//   console.log("whatsapp://send?text=" + message);
//   window.open("whatsapp://send?text=" + message, '_blank' );


// }, false);


// var scrollBack = document.getElementById("scrollBackButton");
// scrollBack.style.display = 'none';

function is_touch_device() {  
  try {  
    document.createEvent("TouchEvent");  
    return true;  
  } catch (e) {  
    return false;  
  }  
}

//console.log(is_touch_device());

document.body.addEventListener('change', function (e) {
  let target = e.target;
  console.log(target.id);
  if(target.id === "langCheckbox")
  {
    //console.log(document.getElementById("muteButtonCkBox").checked);
    if(document.getElementById("langCheckbox").checked)
      console.log("EN"); //off
    else
      console.log("AR"); //on
  }
});

var isTouchScreen = is_touch_device();

init();
animate();


var audioController = new Audio();
// audioController.src = "./sounds/Loop1_StartAmbient.mp3";
// audioController.src = "./sounds/Ascend2City.mp3";;
// audioController.src = "./sounds/Loop2_SceneTwo.mp3";;

var muteButton = document.getElementById("muteButton");
var musicVolume = 1;
// buttonI.innerHTML = "<em>i</em>"
muteButton.addEventListener('click', function() 
{
  controlMuteButton()
}, false);

function controlMuteButton()
{
  if(document.getElementById("muteCheckbox").checked)
  {
    //pause();
    musicVolume = 0;
    TweenMax.to(audioController, 0.3, {volume:musicVolume});
  }
  else 
  {
    //audioController.play();
    musicVolume = 1;
    TweenMax.to(audioController, 0.3, {volume:musicVolume});
  }
}

var trackDuration = 0;

function playAudio(fileName)
{
  
  //if(audioController.playing)
  trackDuration = 0;//audioController.currentTime;
  //if(audioController.playing)
  //{
    //TweenMax.to(audioController, 0.5, {volume:0});
    //audioController.pause();
    //audioController.currentTime = 0;
    //TweenMax.to(audioController, 0.5, {volume:0, onComplete:switchAudio, onCompleteParams:[fileName]});
    switchAudio(fileName);
  //}

    // console.log(audioController);
  // audioController.addEventListener('loadeddata', () => {
  //   //let duration = audioController.duration;
  //   //console.log('load complete ', duration);
  //   // The duration variable now holds the duration (in seconds) of the audio clip 
  //   audioController.muted = false;
  //   audioController.loop = true;
  //   audioController.volume = 0.0;
  //   audioController.play();
  //   TweenMax.to(audioController, 0.5, {volume:1});
  //   audioController.removeEventListener('loadeddata', () => {});
  // });
}

function switchAudio(name)
{
  // console.log("FileName : "+name);

  audioController.src = name;
  //audioController = new Audio(fileName);
  audioController.load();

  audioController.addEventListener('loadeddata', () => {

    audioController.muted = false;
    audioController.loop = true;
    audioController.currentTime = trackDuration;
    //audioController.volume = 0.0;
    audioController.play();
    //TweenMax.to(audioController, 0.5, {volume:musicVolume});

  });
}

// audioController = new Audio("./sounds/Loop1_StartAmbient.mp3");
//   audioController.addEventListener('loadeddata', () => {
//     let duration = audioController.duration;
//     console.log('load complete ', duration);
//     // The duration variable now holds the duration (in seconds) of the audio clip 
//     audioController.loop = true;
//     //audioController.volume = 0.1;
//     audioController.play();
//     TweenMax.to(audioController, 0.5, {volume:0});
//   });
//audioController.play();

var itemsInfoData = [
  {
    zoneNameAR : 'ثقافة غنية و تراث عميق',
    zoneNameEN : 'Rich Culture and Deep Heritage',
    items : [{ 
      headingEN : "Madain Saleh ",
      infoEN : "As if they were paintings made by nature and the most admired historical regions in the Kingdom. As our great leadership made sure to highlight the historical wealth of the Kingdom, it was registered in the UNESCO World Heritage List and made it a tourist and cultural icon, due to its close age of 1900 years, and the presence of a number of distinctive historical monuments and 153 amazing rock sculptures.",
      heading : "مدائن صالح",
      info : "كأنها لوحات فنية من صنع الطبيعة ومن أعجب المناطق التاريخية في المملكة. من حرص قيادتنا الكريمة على إبراز ثروات المملكة التاريخية، تم تسجيلها في قائمة اليونيسكو العالمية في قائمة مواقع التراث العالمي و جعلها أيقونة سياحية و ثقافية، ذلك لعمرها المقارب ل 1900 عام، و لوجود عدد من الآثار التاريخية المميزة بها و153 منحوتة صخرية مدهشة."
    }, {
      headingEN : "Nassif House",
      infoEN : "Is one of the most beautiful palaces in the historical city of Jeddah and has a historical and political presence in the Kingdom, was established in 1289 AH. Built by Sheikh Omar Effendi Nassif, and it is one of the greatest architectural styles in the old city of Jeddah. It was registered in the UNESCO World Heritage List as a heritage landmark in 2014.",
      heading : "بيت نصيف",
      info : "من أجمل قصور مدينة جدة التاريخية وله أهمية تاريخية وسياسية في المملكة، أُنشئ في عام 1289هـ. بناه الشيخ عمر أفندي نصيف وهو أحد الشواهد على النمط المعماري القديم في مدينة جدة تم تسجيله في قائمة اليونيسكو العالمية في قائمة مواقع التراث العالمي كمعلم تراثي في عام 2014."
    }, {
      headingEN : "Al-Ula",
      infoEN : "Jabal Al-Fil (Elephant Rock) is one of the most famous natural landmarks of the kingdom, it's 50 meters height and it is distinguished by its unique shape that resembles an elephant. The rock is surrounded by a group of light-colored mountains. Jabal Al-Feel is located 7 km to the east of Al-Ula Governorate, in Medina region.",
      heading : "العلا",
      info : "جبل الفيل هو أحد أشهر معالم المملكة الطبيعية، يبلغ ارتفاعها عن الأرض 50 متر وتتميز بشكلها الفريد الذي يشبه الفيل وتحيط بالصخرة مجموعة من الجبال ذات الألوان الفاتحة، تشكل هذا الجبل منذ ملايين السنين ليأخذ شكله الحالي لضعف في أجزاء الجبل أثرت فيها عوامل التعرية لتنحته بهذا الشكل، يقع جبل الفيل على بعد ٧ كم إلى جهة الشرق من محافظة العلا التابعة لمنطقة المدينة المنورة."
    }]
  },
  {
    
    zoneNameAR : 'إقتصاد مزدهر ومستقبل واعد',
    zoneNameEN : 'A Prosperous Economy and a Promising Future',

    items : [{
      headingEN : "ITTC (King Abdullah Financial District)",
      infoEN : "The Kingdom was keen to invest in its economy to open many investment opportunities and provide a safe and healthy work environment for everyone, and among these initiatives was the establishment of the King Abdullah Financial District, which represents a very important addition to the high-level economic sector and urban development in Riyadh.",
      heading : "مدينة الملك عبدالله المالية",
      info : "حرصت المملكة على الإستثمار في اقتصادها لفتح العديد من الفرص الاستثمارية وتوفير بيئة عمل آمنة وصحية للجميع، ومن ضمن هذه المبادرات تم تأسيس مركز الملك عبدالله المالي والذي يمثل إضافة بالغة الأهمية للقطاع الاقتصادي والتطوير العمراني راقي المستوى بمدينة الرياض."
    }, {
      headingEN : "Neom",
      infoEN : "The Kingdom is witnessing a rapid cultural and urban growth as a result of demographic, social and economic growth, which led to the implementation of the \"The Future of Saudi Cities\" program with the aim of achieving sustainable urbanization towards the future. Neom city was established to become a global platform through which entrepreneurship and innovation develop.",
      heading : "نيوم",
      info : "تشهد المملكة نموا حضارياً وعمرانياً سريعاً جراء النمو الديمغرافي والاجتماعي والاقتصادي مما أدى إلى تنفيذ برنامج “مستقبل المدن السعودية” بهدف تحقيق التحضر المستدام نحو المستقبل وتم إنشاء مدينة نيوم لتصبحَ منصّة عالمية تنمي من خلالها ريادةُ الأعمال والابتكار"
    }, {
      headingEN : "Futuristic Factory",
      infoEN : "The Kingdom of Saudi Arabia aspires, through its Vision 2030, to expand the elements of sustainable development and supply the national economy with new promising sectors. Therefore, it launched the \"National Industrial Development and Logistics Program\" in order to transform the Kingdom into a leading industrial power and an international logistical platform, as the program provides many developmental opportunities for the future of the Saudi industry.",
      heading : "مستقبل المصانع",
      info : " تطمح المملكة العربية السعودية من خلال رؤيتها 2030  إلى توسيع مقومات التنمية المستدامة، ورفد الاقتصاد الوطني بقطاعات جديدة واعدة، لذا أطلقت برنامج تطوير الصناعة الوطنية والخدمات اللوجستية بغية تحويل المملكة إلى قوة صناعية رائدة ومنصة لوجستية دولية، حيث يتيح البرنامج العديد من الفرص التطويرية  لمستقبل الصناعة السعودية."
    }]
  },
  {
    zoneNameAR : 'رؤية طموحة ونمط حياة استثنائي',
    zoneNameEN : 'Ambitious Vision and an Exceptional Lifestyle',

    items : [{
      headingEN : "Entertainment",
      infoEN : "MDL BEAST festival, is the first major international music festival in Saudi Arabia and is one of the initiatives developed and organized that aims to provide different types of cultural entertainment to the public in addition to contributing to improving the nation’s quality of life as well as support the cultural infrastructure in the Kingdom.",
      heading : "الترفيه",
      info : "مهرجان ميدل بيست، يعد أول مهرجان موسيقي ضخم على مستوى عالمي، وهو أحد المبادرات المطورة والمنظمة التي تهدف لتقديم وتوفير مختلف أنواع الثقافات والترفيه، بما يساهم في تحسين جودة الحياة ودعم البنية التحتية الثقافية في المملكة."
    }, {
      headingEN : "Sports",
      infoEN : "Sports cities are an innovative and modern landmark that translates the Kingdom's interest in sports as a lifestyle and its importance to highlight the capabilities of the Kingdom's young men and women globally, and it is a testament to its efforts and ambitious steps towards sports excellence by providing the best attractive sports facilities according to the highest international standards.",
      heading : "الرياضة",
      info : "المدن الرياضية، تعد معلماً إبداعياً وعصرياً،  تترجم عناية المملكة بالرياضة كنمط حياة وأهميتها لإبراز قدرات شباب وشابات المملكة عالمياً، وهي شاهد على جهودها وخطواتها الطموحة نحو الامتياز الرياضي بتوفير أفضل المرافق الرياضية الجاذبة وفق أعلى المعايير العالمية."
    }, {
      headingEN : "Medical Sector",
      infoEN : "Health organizations in the Kingdom have paid great attention to comprehensive healthcare, and have made great efforts to improve the quality of medical services and facilitate access to them. Human health is at the forefront of its priorities. Its unique and proactive experiences in this field are the best witness to this, and in the challenge of the Covid-19 pandemic it has proven its readiness and ability to maintain the health and safety of individuals and society.",
      heading : "القطاع الصحي",
      info : "المنظمات الصحية أولت المملكة عناية فائقة  بالرعاية الصحية الشاملة ، وبذلت جهودا عظيمة في تحسين جودة الخدمات الطبية وتسهيل الحصول عليها ،  فصحة الإنسان في مقدمة أولوياتها. وتجاربها الفريدة والسباقة في هذا المجال، خير شاهد على ذلك، وقد أثبتت  في مواجهتها لجائحة كورونا مدى جاهزيتها وقدرتها على المحافظة على صحة وسلامة الفرد"
    }]
  }
];

// {

//   zoneElements : [{

//   }, {

//   }, {

//   }]

//   // NassiefHouse : "ثقافة غنية و تراث عميق",
//   // NassiefHouseInfo : "بيت نصيف،  القصر الأشهر والأقدم في مدينة جدة، وأحد أبرز معالمها السياحية، امتزج بين جنباته التاريخ بالسياسة، تميز بطلته البهية ونمطه المعماري الذي يحكي عن حقبة تاريخية فريدة لهذه المدينة العريقة، بناه الشيخ عمر أفندي نصيف عام 1289هـ، تم تسجيله كمعلم تراثي في قائمة اليونسكو للتراث العالمي عام ٢٠١٤م",
//   // MadainSaleh  : "ثقافة غنية و تراث عميق",
//   // MadainSalehInfo  : "مدائن صالح، (مدينة الحِجْر) موقع أثري قديم، يعود تاريخها إلى عام ١٧٠٠ قبل الميلاد. تُظهر أطلالها الأعمال الهندسية الرائعة التي اشتهر بها الأنباط، فهناك 153 واجهة صخرية منحوتة في وسط عالم متموج من الرمال، إضافة إلى عدد من الآثار الإسلامية. وهي أول موقع في السعودية تم تسجيلها في قائمة اليونسكو للتراث العالمي عام  ٢٠٠٨م"

// };
//var isLocked = false;


function onBackButtonPressed()
{
  //console.log('clicked!');
  if(transitionParams.transition===0)
  {
    currentZoneSelected = 1;
    transitionParams.animateTransition = true;
    //var xBody = document.getElementsByTagName("BODY")[0];
    //bodyElement.style.overflowY = 'scroll';

    disableBodyScroll(bodyElement);

    var xBody = document.getElementById("overlay");
    xBody.style.display = 'none';

    xBody = document.getElementById("itemsInfo");
    xBody.style.display = 'none';

    zonePanel.style.display = 'none';

    rotateDiv.style.top = '80%';
    rotateDiv.style.left = '40%';

    //playAudio("./sounds/City.mp3");
    // document.body.scrollTop = 1000;
    // window.scroll(0,1);
    //scrollBack.style.display = 'block';
  }
}

function onInfoButtonClicked()
{
  var xBody = document.getElementById("itemsDetails");
  //console.log(xBody.style.display);
  if(xBody.style.display === 'none')
  {
    xBody.style.display = 'block';

    // xBody = document.getElementById("itemsHeading");
    // if(languageSelected === 1)
    // {
    //   xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].headingEN;
    //   xBody.style.textAlign = 'left';
    // }
    // else
    // {
    //   xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].heading;
    //   xBody.style.textAlign = 'right';
    // }

    // xBody = document.getElementById("itemsDetails");
    if(languageSelected === 1)
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].infoEN;
      xBody.style.textAlign = 'left';
    }
    else
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].info;
      xBody.style.textAlign = 'right';
    }
    //xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].info;
   
  }
  else
  {
    xBody.style.display = 'none';
  }
}

function ResetHtmlCityInfoScene()
{
  var xBody = document.getElementById("itemsInfo");
  xBody.style.display = 'block';

  xBody = document.getElementById("itemsDetails");
  xBody.style.display = 'none';
}

function hideAddressBar()
{
  if(!window.location.hash)
  {
      if(document.height < window.outerHeight)
      {
          document.body.style.height = (window.outerHeight + 50) + 'px';
      }

      setTimeout( function(){ window.scrollTo(0, 1); }, 100 );
  }

  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) 
  { 
    // When ready, auto-scroll 1px to hide URL bar
    window.addEventListener("load", function () {
        // Set a timeout...
        setTimeout(function () {
            // Hide the address bar!
            window.scrollTo(0, 1);
        }, 100);
    });
  }
}

window.addEventListener("load", function(){ if(!window.pageYOffset){ hideAddressBar(); } } );
window.addEventListener("orientationchange", hideAddressBar );

function onStartButtonPressed()
{
  console.log('Start Clicked!');

  playAudio("./sounds/bg.mp3");
  // var myMusic = document.getElementById('player');
  //   console.log(myMusic);
  //   myMusic.muted = false;
  //   myMusic.play();

  // audioController.addEventListener('loadeddata', () => {
  //   let duration = audioController.duration;
  //   console.log('load complete ', duration);
  //   // The duration variable now holds the duration (in seconds) of the audio clip 
  //   audioController.play();
  // });

  // audioController.src = "./sounds.BG.mp3";
  // audioController.load();
  // audioController.muted = false;
 

  //var xBody = document.getElementsByTagName("BODY")[0];
  // bodyElement.style.overflowY = 'scroll';

  enableBodyScroll(bodyElement);

  var startButton = document.getElementById("startButton");
  startButton.style.display = 'none';

  var scrollDiv = document.getElementById("scrollDiv");
  scrollDiv.style.display = 'block';
}

function onLangButtonPressed()
{
  // var langButton = document.getElementById("languageButton");
  // if(langButton.innerHTML === "ع")
  // {
  //   languageSelected = 0;
  //   langButton.innerHTML = "EN";
  //   //langButton.style.fontFamily = "formulaCondensed"
  //   //langButton.style.fontSize = '1.3vw'
  // }
  // else
  // {
  //   languageSelected = 1;
  //   langButton.innerHTML = "ع";
  //   //langButton.style.fontFamily = "AlmaraiBold" 
  //   //langButton.style.fontSize = '1.5vw'
  // }
  if(document.getElementById("langCheckbox").checked)
  {
    languageSelected = 1;
  }
  else 
  {
    languageSelected = 0;
  }

  languageChangeRefrash();
}

function resetScrollPos(selector) {
  var divs = document.querySelectorAll(selector);
  for (var p = 0; p < divs.length; p++) {
    if (Boolean(divs[p].style.transform)) { //for IE(10) and firefox
      divs[p].style.transform = 'translate3d(0px, 0px, 0px)';
    } else { //for chrome and safari
      divs[p].style['-webkit-transform'] = 'translate3d(0px, 0px, 0px)';
    }
  }
}

var bodyElement;

function init() 
{
  window.scrollTo(0,0); 

  
  // var audio = new Audio('./sounds/BG.mp3');
  // audio.play();

  //resetScrollPos('body');
  var myDiv = document.getElementById('root');
  myDiv.scrollTo(0,0);// = 0;

  bodyElement = document.getElementsByTagName("BODY")[0];
  bodyElement.style.overflowY = 'hidden';

  // bodyElement = document.getElementById("experiance");

  disableBodyScroll(bodyElement);
  //console.log("Aspect ratio : width : " + window.innerWidth + " height : " + window.innerHeight + "  ratio : " +(window.innerWidth / window.innerHeight));
 
  //initGUI();
  document.getElementById('imgMountain').draggable = false;

	container = document.getElementById( "root" );
  renderer = new THREE.WebGLRenderer( { antialias: true} );
  console.log(window.devicePixelRatio);
	renderer.setPixelRatio(2);// window.devicePixelRatio );
	renderer.setSize( window.innerWidth, window.innerHeight );
  container.appendChild( renderer.domElement );
  
	//stats = new Stats();
  //container.appendChild( stats.dom );
  
	var sceneA = new City();//FXScene( "cube", 5000, 1200, 120, new THREE.Vector3( 0, - 0.4, 0 ), 0xffffff );
  var sceneB = new CityInfo();//FXScene( "sphere", 500, 2000, 50, new THREE.Vector3( 0, 0.2, 0.1 ), 0xff0000 );
  
  transition = new Transition( sceneA, sceneB );
  
  // scrollBack.addEventListener('click', function(){
  //   onScrollBackButtonClicked();
  // }, false);

  var startButton = document.getElementById("startButton");
  startButton.style.color = 0xffffff;

  startButton.addEventListener('click', function() {
    onStartButtonPressed();
  }, false);

  var langButton = document.getElementById("languageButton");
  langButton.addEventListener('click', function() {
    onLangButtonPressed();
  }, false);


  //var element = document.getElementById("overlay");

  // var button = document.createElement("button");
  // button.setAttribute("class", "backButton btn");
  // button.type  = 'button';
  // button.innerHTML = 'Back';
  // element.appendChild(button);

  // var buttonI = document.createElement("button");
  // buttonI.setAttribute("class", "btn");
  // buttonI.type  = 'button';
  // buttonI.innerHTML = 'i';
  // buttonI.style.top = "25%";
  // buttonI.style.left = "50%";
  // element.appendChild(buttonI);

  // var buttonR = document.createElement("button");
  // buttonR.setAttribute("class", "btn");
  // buttonR.type  = 'button';
  // buttonR.innerHTML = '>';
  // buttonR.style.top = "50%";
  // buttonR.style.left = "95%";
  // element.appendChild(buttonR);

  // var buttonL = document.createElement("button");
  // buttonL.setAttribute("class", "btn");
  // buttonL.type  = 'button';
  // buttonL.innerHTML = '<';
  // buttonL.style.top = "50%";
  // buttonL.style.left = "5%";
  // element.appendChild(buttonL);

  // button.setAttribute("class", "btnL");
  // button.type  = 'button';
  // button.innerHTML = '<';

  // element.appendChild(button);

  var button = document.getElementById("backButton");
  button.addEventListener('click', function() {
    onBackButtonPressed()
  }, false);

  var buttonR = document.getElementById("rightButton");
  // buttonR.innerHTML = "<em>></em>"
  buttonR.addEventListener('click', function() {
    onRightArrowClicked()
  }, false);

  var buttonL = document.getElementById("leftButton");
  // buttonL.innerHTML = "<em><</em>"
  buttonL.addEventListener('click', function() {
    onLeftArrowClicked()
  }, false);

  var buttonI = document.getElementById("infoButton");
  // buttonI.innerHTML = "<em>i</em>"
  buttonI.addEventListener('click', function() {
    onInfoButtonClicked()
  }, false);
}


// function onScrollBackButtonClicked()
// {
//   //fullTimeline.seek(5);
//   //window.scrollByPages(1);
//   window.scrollBy(0, -window.innerHeight * 0.4);
//   onScrollBackComplete();
//   //TweenMax.to(cCamera.position, 1, {y:3250, z:450, onComplete:onScrollBackComplete} );
// }

// function onScrollBackComplete()
// {
//   isReachedCity=false;
//   scrollBack.style.display = 'none';
//   enableBodyScroll(bodyElement);
// }

function animate() {
	requestAnimationFrame( animate );
  render();
  
	//stats.update();
}

// function initGUI() {
// 	var gui = new GUI();
// 	gui.add( transitionParams, "useTexture" ).onChange( function ( value ) {
// 		transition.useTexture( value );
// 	} );
// 	gui.add( transitionParams, 'loopTexture' );
// 	gui.add( transitionParams, 'texture', { Perlin: 0, Squares: 1, Cells: 2, Distort: 3, Gradient: 4, Radial: 5 } ).onChange( function ( value ) {
// 		transition.setTexture( value );
// 	} ).listen();
// 	gui.add( transitionParams, "textureThreshold", 0, 1, 0.01 ).onChange( function ( value ) {
// 		transition.setTextureThreshold( value );
// 	} );
// 	gui.add( transitionParams, "animateTransition" );
// 	gui.add( transitionParams, "transition", 0, 1, 0.01 ).listen();
// 	gui.add( transitionParams, "transitionSpeed", 0.5, 5, 0.01 );
// }

function render() 
{
	transition.render( clock.getDelta() );
}

// function loadMusic(camera)
// {
//   // create an AudioListener and add it to the camera
//   var listener = new THREE.AudioListener();
//   camera.add( listener );

//   // create a global audio source
//   var sound = new THREE.Audio( listener );

//   // load a sound and set it as the Audio object's buffer
//   var audioLoader = new THREE.AudioLoader();
//   audioLoader.load( './sounds/bg2.ogg', function( buffer ) {
//     //console.log("Music");
//     sound.setBuffer( buffer );
//     sound.setLoop( true );
//     sound.setVolume( 0.5 );
//     sound.play();
//   });
  
// }

function Transition( sceneA, sceneB ) 
{
  this.scene = new THREE.Scene();
  
  this.cameraOrtho = new THREE.OrthographicCamera( window.innerWidth / - 2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / - 2, - 10, 10 );

	this.textures = [];
	var loader = new THREE.TextureLoader();
	
  this.transitionTexture = loader.load( './assets/transition.png' );
    
	this.quadmaterial = new THREE.ShaderMaterial( {
		uniforms: {
			tDiffuse1: {
				value: null
			},
			tDiffuse2: {
				value: null
			},
			mixRatio: {
				value: 0.0
			},
			threshold: {
				value: 0.1
			},
			useTexture: {
				value: 1
			},
			tMixTexture: {
				value: this.transitionTexture
			}
		},
		vertexShader: [
			"varying vec2 vUv;",
			"void main() {",
			"vUv = vec2( uv.x, uv.y );",
			"gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
			"}"
		].join( "\n" ),
		fragmentShader: [
			"uniform float mixRatio;",
			"uniform sampler2D tDiffuse1;",
			"uniform sampler2D tDiffuse2;",
			"uniform sampler2D tMixTexture;",
			"uniform int useTexture;",
			"uniform float threshold;",
			"varying vec2 vUv;",
			"void main() {",
			"	vec4 texel1 = texture2D( tDiffuse1, vUv );",
			"	vec4 texel2 = texture2D( tDiffuse2, vUv );",
			"	if (useTexture==1) {",
			"		vec4 transitionTexel = texture2D( tMixTexture, vUv );",
			"		float r = mixRatio * (1.0 + threshold * 2.0) - threshold;",
			"		float mixf=clamp((transitionTexel.r - r)*(1.0/threshold), 0.0, 1.0);",
			"		gl_FragColor = mix( texel1, texel2, mixf );",
			"	} else {",
			"		gl_FragColor = mix( texel2, texel1, mixRatio );",
			"	}",
			"}"
		].join( "\n" )
  } );
  
	var quadgeometry = new THREE.PlaneBufferGeometry( window.innerWidth, window.innerHeight );
	this.quad = new THREE.Mesh( quadgeometry, this.quadmaterial );
  this.scene.add( this.quad );
  
	// Link both scenes and their FBOs
	this.sceneA = sceneA;
  this.sceneB = sceneB;
  
	this.quadmaterial.uniforms.tDiffuse1.value = sceneA.fbo.texture;
  this.quadmaterial.uniforms.tDiffuse2.value = sceneB.fbo.texture;
  
  this.needChange = false;
  
	this.setTextureThreshold = function ( value ) {
		this.quadmaterial.uniforms.threshold.value = value;
  };
  
	this.useTexture = function ( value ) {
		this.quadmaterial.uniforms.useTexture.value = value ? 1 : 0;
  };
  
	this.setTexture = function ( i ) {
		this.quadmaterial.uniforms.tMixTexture.value = this.transitionTexture;
  };
  
  if ( transitionParams.loopTexture && ( transitionParams.transition === 0 || transitionParams.transition === 1 ) ) {
    if ( this.needChange ) {
      transitionParams.texture = 0;//( transitionParams.texture + 1 ) % this.textures.length;
      this.quadmaterial.uniforms.tMixTexture.value = this.transitionTexture;//this.textures[ transitionParams.texture ];
      this.needChange = false;
    }
  } else
    this.needChange = true;
    transitionParams.transition = 1;
    transitionParams.animateTransition = false;

  function updateTransitionState()
  {
    transitionParams.animateTransition = false;
  }

	this.render = function ( delta ) {
    // Transition animation
    //console.log(transitionParams.transition);

		if ( transitionParams.animateTransition ) {
			//var t = (Math.sin( transitionParams.transitionSpeed * clock.getElapsedTime() / Math.PI ) ) / 2;
      //transitionParams.transition =  THREE.MathUtils.smoothstep( t, 0.3, 0.7 );

      if ( transitionParams.transition === 0)
      TweenMax.to(transitionParams, 0.1, {transition:1, onComplete:updateTransitionState, ease:"none"});
      else
      TweenMax.to(transitionParams, 0.1, {transition:0, onComplete:updateTransitionState, ease:"none"});

      transitionParams.animateTransition = false;
      // if(transitionParams.transition<=0)
      // {

      // }
      // else
      // {

      // }

      // if ( transitionParams.transition == 0 || transitionParams.transition == 1 )
      // {
      //   transitionParams.animateTransition = false;
      // }
			//Change the current alpha texture after each transition
			// if ( transitionParams.loopTexture && ( transitionParams.transition == 0 || transitionParams.transition == 1 ) ) {
			// 	if ( this.needChange ) {
			// 		transitionParams.texture = 0;//( transitionParams.texture + 1 ) % this.textures.length;
			// 		this.quadmaterial.uniforms.tMixTexture.value = this.transitionTexture;//this.textures[ transitionParams.texture ];
			// 		this.needChange = false;
			// 	}
			// } else
			// 	this.needChange = true;
		}
		this.quadmaterial.uniforms.mixRatio.value = transitionParams.transition;
		// Prevent render both scenes when it's not necessary
		if ( transitionParams.transition === 0 ) {
      this.sceneB.render( delta, false );
      //transitionParams.animateTransition = false;
		} else if ( transitionParams.transition === 1 ) {
      this.sceneA.render( delta, false );
      //transitionParams.animateTransition = false;
		} else {
			// When 0<transition<1 render transition between two scenes
			this.sceneA.render( delta, true );
			this.sceneB.render( delta, true );
			renderer.setRenderTarget( null );
			renderer.clear();
			renderer.render( this.scene, this.cameraOrtho );
		}
	};
}

//---------------------------------------City------------------------------------------------------
var isCityLoaded = false;

window.addEventListener( 'resize', onWindowResize, false );

document.addEventListener('mousemove', onDocumentMouseMove, false);
document.addEventListener('mousedown', onDocumentMouseDown, false);
document.addEventListener('mouseup', onDocumentMouseUp, false);

document.addEventListener("touchstart", onDocumentTouchStart, false);
document.addEventListener("touchmove", onDocumentTouchMove, false);
document.addEventListener("touchend", onDocumentTouchEnd, false);

///// wireframe Material
var API = {
  widthFactor: 1
};
var uniforms = { 'widthFactor': { value: API.widthFactor } };
var wireframeMaterial = new THREE.ShaderMaterial( {

  uniforms: uniforms,
  vertexShader: document.getElementById( 'vertexShader' ).textContent,
  fragmentShader: document.getElementById( 'fragmentShader' ).textContent,
  side: THREE.DoubleSide

} );
wireframeMaterial.extensions.derivatives = true;

var cCamera, cScene;

var isWindowResized = false;
var counterToCheckScroll = 0;

function City() 
{
  var overlay = document.getElementById("overlay");
  overlay.style.display = 'none';

  overlay = document.getElementById("itemsInfo");
  overlay.style.display = 'none';
  zoneHeading.style.display = 'none';
  zonePanel.style.display = 'none';
  
  this.clearColor = 0xffffff;
  
	this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000 );
  this.camera.position.z = 100;
  
  //sceneCameras.push(this.camera);
	// Setup scene
  this.scene = new THREE.Scene();

  cCamera = this.camera;
  cScene = this.scene;
  
  // this.scene.add( new THREE.AmbientLight( 0x555555 ) );
  
	// var light = new THREE.SpotLight( 0xffffff, 1.5 );
	// light.position.set( 0, 500, 2000 );
  // this.scene.add( light );
  
  loadCity(this.scene, this.camera);

	var renderTargetParameters = { minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter, format: THREE.RGBFormat, stencilBuffer: false };
  this.fbo = new THREE.WebGLRenderTarget( window.innerWidth, window.innerHeight, renderTargetParameters );

	this.render = function ( delta, rtt ) {
		
		renderer.setClearColor( this.clearColor);
		if ( rtt ) {
			renderer.setRenderTarget( this.fbo );
			renderer.clear();
			renderer.render( this.scene, this.camera );
		} else {
      renderer.setRenderTarget( null );

      if(isCityLoaded){
      updateParticles(this.scene);
      updateCloudSystem();

      pinZ1.lookAt(sceneCityCamera[0].position);
      pinZ2.lookAt(sceneCityCamera[0].position);
      pinZ3.lookAt(sceneCityCamera[0].position);

      counterToCheckScroll++;

      if(isReachedCity && counterToCheckScroll > 30)
      {
        if(window.scrollY < document.body.scrollHeight)
        {
          window.scroll(0,document.body.scrollHeight);
          //isWindowResized = false;
          counterToCheckScroll = 0;
        }

      }
      // backgroundPlane.position.y = this.camera.position.y - 300;
      // backgroundPlane.position.z = this.camera.position.z - 1000;

      // backgroundPlane.rotation.x = this.camera.rotation.x;

      //console.log(backgroundPlane.rotation.x, this.camera.rotation.x);
      }
      //if(!isTouchScreen)
        checkForZoneElements(this.scene, this.camera, mouse);
      //else
        //checkForZoneElements(this.scene, this.camera, touch);

      if(this.camera.position.z > 435)
        appState = 0;

      if(this.camera.position.y > 3250 && this.camera.position.z < 350)
        appState = 1;

			renderer.render( this.scene, this.camera );
		}
  };
  
  
}

var mouse = new THREE.Vector2();

var isMouseDown = false;
var isDragging = false;
var isTouchDragging = false;

var previousMousePosition = {
    x: 0,
    y: 0
};

var raycaster = new THREE.Raycaster();
raycaster.params.Line.threshold = 100;

var whichZoneFound = "";
var zone1 = null, zone2 = null, zone3 = null;
//var baseZone1 = null, baseZone2 = null, baseZone3 = null;
// document.addEventListener("drag", onUserDrag());

// function onUserDrag(event)
// {
  
// }

var textShowOp = 0;
var zoneAnimation = 1;
var zoneAnimationCounter = 0;

function checkForZoneElements(cityScene, cityCamera, mousePos) {
  // find intersections

  zoneAnimationCounter++;
  if(zoneAnimationCounter > 100)
  {
    zoneAnimationCounter = 0;
    zoneAnimation++;
    if(zoneAnimation>=4)
    {
      zoneAnimation = 1;
    }
  }

  if(isCityLoaded && transitionParams.transition===1)
  {
    raycaster = new THREE.Raycaster();
    raycaster.setFromCamera( mousePos, cityCamera );

    //var foundTarget = false;
    // calculate objects intersecting the picking ray
    var intersects = raycaster.intersectObjects( cityScene.children, true );

    //console.log(mousePos, intersects);
    whichZoneFound = "";
    
    // cultureTextAR.visible = false;
    // lifestyleTextAR.visible = false;
    // economyTextAR.visible = false;

    // cultureTextEN.visible = false;
    // lifestyleTextEN.visible = false;
    // economyTextEN.visible = false;

    if(appState===1)
    {
      for ( var i = 0; i < intersects.length; i++ ) 
      {
        //console.log(intersects[ i ].object.parent.name);
        if(intersects[ i ].object.parent.name === "zone1" && whichZoneFound==="")// || intersects[ i ].object.parent.name === "zone2" || intersects[ i ].object.parent.name === "zone3")
        {
          if(zone1!=null)
          {
            zone1.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xefeb83 );
                var target = new THREE.Color(0xFAA61A);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            zone2.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xefeb83 );
                var target = new THREE.Color(0xffffff);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            zone3.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xefeb83 );
                var target = new THREE.Color(0xffffff);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );
            
            // baseZone1.traverse( function ( child ) {            
            //   if ( child.isMesh ) {                
            //     //child.material.color.set( 0xffffff );
            //     var target = new THREE.Color(0xffffff);
            //     TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
            //   }
            // } );

            if(languageSelected === 1)
            {
              if(textShowOp===1)
              {
                //cultureTextEN.visible = true;
              }
              else{
              zoneTitle.style.display = 'block';
              zoneName.innerHTML = itemsInfoData[0].zoneNameEN;
              zoneName.style.textAlign = 'left';}
            }
            else
            {
              if(textShowOp===1)
              {
                //cultureTextAR.visible = true;
              }
              else{
              zoneTitle.style.display = 'block';
              zoneName.innerHTML = itemsInfoData[0].zoneNameAR;
              zoneName.style.textAlign = 'right';}
            }

            whichZoneFound = "z1";
            currentZoneSelected = 1;
            break;
          }
        }
        // else
        // {
        //   if(zone1!=null)
        //   {
        //     zone1.traverse( function ( child ) {            
        //       if ( child.isMesh ) {                
        //         //child.material.color.set( 0xffffff );
        //         var target = new THREE.Color(0xffffff);
        //         child.material.color.set( target );
        //         //TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //       }
        //     } );

        //     // baseZone1.traverse( function ( child ) {            
        //     //   if ( child.isMesh ) {                
        //     //     //child.material.color.set( 0xffffff );
        //     //     var target = new THREE.Color(0x000000);
        //     //     TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //     //   }
        //     // } );
        //   }
        // }
        
        if(intersects[ i ].object.parent.name === "zone2" && whichZoneFound==="")// || intersects[ i ].object.parent.name === "zone2" || intersects[ i ].object.parent.name === "zone3")
        {
          if(zone2!=null)
          {
            zone2.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0x3d60b0 );
                var target = new THREE.Color(0xFAA61A);//0xF7941D);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            zone1.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xefeb83 );
                var target = new THREE.Color(0xffffff);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            zone3.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xefeb83 );
                var target = new THREE.Color(0xffffff);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            // baseZone3.traverse( function ( child ) {            
            //   if ( child.isMesh ) {                
            //     //child.material.color.set( 0xffffff );
            //     var target = new THREE.Color(0xffffff);
            //     TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
            //   }
            // } );

            // if(languageSelected === 1)
            // economyTextEN.visible = true;
            // else
            // economyTextAR.visible = true;

            if(languageSelected === 1)
            {
              if(textShowOp===1)
              {
                //economyTextEN.visible = true;
              }
              else{
              zoneTitle.style.display = 'block';
              zoneName.innerHTML = itemsInfoData[1].zoneNameEN;
              zoneName.style.textAlign = 'left';}
            }
            else
            {
              if(textShowOp===1)
              {
                //economyTextAR.visible = true;
              }
              else{
              zoneTitle.style.display = 'block';
              zoneName.innerHTML = itemsInfoData[1].zoneNameAR;
              zoneName.style.textAlign = 'right';}
            }

            //economyTextAR.visible = true;
            whichZoneFound = "z2";
            currentZoneSelected = 2;
            break;
          }
        }
        // else
        // {
        //   if(zone2!=null)
        //   {
        //     zone2.traverse( function ( child ) {            
        //       if ( child.isMesh ) {                
        //         //child.material.color.set( 0xffffff );
        //         var target = new THREE.Color(0xffffff);
        //         child.material.color.set( target );
        //         //TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //       }
        //     } );

        //     // baseZone3.traverse( function ( child ) {            
        //     //   if ( child.isMesh ) {                
        //     //     //child.material.color.set( 0xffffff );
        //     //     var target = new THREE.Color(0x000000);
        //     //     TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //     //   }
        //     // } );
        //   }
        // }

        if(intersects[ i ].object.parent.name === "zone3" && whichZoneFound==="")// || intersects[ i ].object.parent.name === "zone2" || intersects[ i ].object.parent.name === "zone3")
        {
          if(zone3!=null)
          {
            zone3.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xe183ef );
                var target = new THREE.Color(0xFAA61A);//0xF37021);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            zone2.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xefeb83 );
                var target = new THREE.Color(0xffffff);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            zone1.traverse( function ( child ) {            
              if ( child.isMesh ) {                
                //child.material.color.set( 0xefeb83 );
                var target = new THREE.Color(0xffffff);
                child.material.color.set( target );
                //TweenMax.to(child.material.color, 0.1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
              }
            } );

            // baseZone2.traverse( function ( child ) {            
            //   if ( child.isMesh ) {                
            //     //child.material.color.set( 0xffffff );
            //     var target = new THREE.Color(0xffffff);
            //     TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
            //   }
            // } );
            
            // if(languageSelected === 1)
            //   lifestyleTextEN.visible = true;
            // else
            //   lifestyleTextAR.visible = true;

            if(languageSelected === 1)
            {
              if(textShowOp===1)
              {
              //lifestyleTextEN.visible = true;
              }
              else{
              zoneTitle.style.display = 'block';
              zoneName.innerHTML = itemsInfoData[2].zoneNameEN;
              zoneName.style.textAlign = 'left';}
            }
            else
            {
              if(textShowOp===1)
              {
              //lifestyleTextAR.visible = true;
              }
              else{
              zoneTitle.style.display = 'block';
              zoneName.innerHTML = itemsInfoData[2].zoneNameAR;
              zoneName.style.textAlign = 'right';}
            }

            //lifestyleTextAR.visible = true;
            whichZoneFound = "z3";
            currentZoneSelected = 3;
            break;
          }
        }
        // else
        // {
        //   if(zone3!=null)
        //   {
        //     zone3.traverse( function ( child ) {            
        //       if ( child.isMesh ) {                
        //         //child.material.color.set( 0xffffff );
        //         var target = new THREE.Color(0xffffff);
        //         //var target = new THREE.Color(0x03007C06);
        //         child.material.color.set( target );
        //         //TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //       }
        //     } );
        //     // baseZone2.traverse( function ( child ) {            
        //     //   if ( child.isMesh ) {                
        //     //     //child.material.color.set( 0xffffff );
        //     //     var target = new THREE.Color(0x000000);
        //     //     TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //     //   }
        //     // } );
        //   }
        // }
      }
    }
  }

  if(whichZoneFound==="")
    {
      if(zone1!=null)
      {
        zone1.traverse( function ( child ) {            
          if ( child.isMesh ) {                
            //child.material.color.set( 0xffffff );
            var target = new THREE.Color(0xffffff);
            if(zoneAnimation===1)
            {
              target = new THREE.Color(0xF3843C);
            }

            //var target = new THREE.Color(0xffffff);
            child.material.color.set( target );
            //TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );

            //cultureTextAR.visible = false;
            //cultureTextEN.visible = false;

            zoneTitle.style.display = 'none';
            zoneName.innerHTML = "";
          }
        } );

        // baseZone1.traverse( function ( child ) {            
        //   if ( child.isMesh ) {                
        //     //child.material.color.set( 0xffffff );
        //     var target = new THREE.Color(0x000000);
        //     child.material.color.set( target );
        //     TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //   }
        // } );
      }

      if(zone2!=null)
      {
        zone2.traverse( function ( child ) {            
          if ( child.isMesh ) {                
            //child.material.color.set( 0xffffff );
            var target = new THREE.Color(0xffffff);
            if(zoneAnimation===2)
            {
              target = new THREE.Color(0xF3843C);
            }
            child.material.color.set( target );
            TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );

            //lifestyleTextAR.visible = false;
            //lifestyleTextEN.visible = false;

            zoneTitle.style.display = 'none';
            zoneName.innerHTML = "";
          }
        } );

        // baseZone3.traverse( function ( child ) {            
        //   if ( child.isMesh ) {                
        //     //child.material.color.set( 0xffffff );
        //     var target = new THREE.Color(0x000000);
        //     child.material.color.set( target );
        //     //TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //   }
        // } );
      }
    
      if(zone3!=null)
      {
        zone3.traverse( function ( child ) {            
          if ( child.isMesh ) {                
            //child.material.color.set( 0xffffff );
            var target = new THREE.Color(0xffffff);
            if(zoneAnimation===3)
            {
              target = new THREE.Color(0xF3843C);
            }
            child.material.color.set( target );
            //TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );

            //economyTextAR.visible = false;
            //economyTextEN.visible = false;

            zoneTitle.style.display = 'none';
            zoneName.innerHTML = "";
          }
        } );

        // baseZone2.traverse( function ( child ) {            
        //   if ( child.isMesh ) {                
        //     //child.material.color.set( 0xffffff );
        //     var target = new THREE.Color(0x000000);
        //     child.material.color.set( target );
        //     //TweenMax.to(child.material.color, 1, {r:target.r, g:target.g, b:target.b, ease:Power2.easeOut} );
        //   }
        // } );
      }
    }
}

function onDocumentMouseMove(event) 
{
  if(isMouseDown)
    isDragging = true;

  if(!isTouchScreen)
  {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  }

  var deltaMove = 
  {
    x: event.offsetX-previousMousePosition.x,
    y: event.offsetY-previousMousePosition.y
  };

  if(isDragging && appState===1 && transitionParams.transition===1) 
  {
    var deltaRotationQuaternion = new THREE.Quaternion()
        .setFromEuler(new THREE.Euler(
            0,
            (deltaMove.x * 0.2 * 0.0174533),
            0,
            'XYZ'
        ));

    fCity.quaternion.multiplyQuaternions(deltaRotationQuaternion, fCity.quaternion);

    // if(fCity.rotation.y < MathUtils.degToRad(65) && fCity.rotation.y > MathUtils.degToRad(-25))
    // {
    //   //MathUtils.clamp(deltaRotationQuaternion.yaw, MathUtils.degToRad(-45), MathUtils.degToRad(45))
    //   fCity.quaternion.multiplyQuaternions(deltaRotationQuaternion, fCity.quaternion);
    //   //fCity.rotation.y += MathUtils.degToRad(deltaMove.x);
    // }
    // //else
    // //{
    //   if(fCity.rotation.y <= MathUtils.degToRad(-25))
    //     fCity.rotation.y = MathUtils.degToRad(-24.99);
    //   else if(fCity.rotation.y >= MathUtils.degToRad(65))
    //     fCity.rotation.y = MathUtils.degToRad(64.99);
    //}
    
  }

  if(transitionParams.transition===0 && !isAnimatingItemInfo)
  {
    //console.log(mouse);
    var itemToShow = ((currentZoneSelected-1) * itemsPerZone) + currentItem;//(numberOfZones*itemsPerZone) 

    TweenMax.to(sceneCityInfoCamera[0].position, 0.3, {x:(itemsCameraPos[itemToShow].x + (mouse.x)), y:(itemsCameraPos[itemToShow].y + (mouse.y)), z:itemsCameraPos[itemToShow].z, ease:"none"});
    //TweenMax.to(sceneCityInfoCamera[0].rotation, 0.3, {y:THREE.MathUtils.degToRad(itemsCameraRot[itemToShow] + (mouse.x * 10)), ease:"none"});

  }
  
  if(transitionParams.transition===0 && !isAnimatingItemInfo && isDragging)
  {
    var deltaRotation = new THREE.Quaternion()
        .setFromEuler(new THREE.Euler(
            0,
            (deltaMove.x * 0.2 * 0.0174533),
            0,
            'XYZ'
        ));

    var itemToRotate = ((currentZoneSelected-1) * itemsPerZone) + currentItem;
    //items3DModels[itemToRotate].position.y = items3DModelsPos[itemToRotate].y + 10;
    //items3DModels[itemToRotate].quaternion.multiplyQuaternions(deltaRotation, items3DModels[itemToRotate].quaternion);
    //console.log(items3DModels[itemToRotate].name);
    liftHero(itemToRotate, 1);
    rotateHero(itemToRotate, deltaRotation);
  }

  previousMousePosition = {x: event.offsetX, y: event.offsetY};
}

function onDocumentMouseDown(event) 
{
  isMouseDown = true;

  
}
function onDocumentMouseUp(event) 
{
  if(!isTouchScreen && !isDragging && isCityLoaded && transitionParams.transition===1)
  {
    if(whichZoneFound==="z1" || whichZoneFound==="z2" || whichZoneFound==="z3")
    {
      whichZoneFound = "";
      if(transitionParams.transition===1)
      {
        transitionParams.animateTransition = true;
        //var xBody = document.getElementsByTagName("BODY")[0];
        bodyElement.style.overflowY = 'hidden';
        disableBodyScroll(bodyElement);

        var xBody = document.getElementById("overlay");
        xBody.style.display = 'block';

        //xBody = document.getElementById("itemsInfo");
       
        zonePanel.style.display = 'block';
        zoneHeading.style.display = 'block';
        //xBody.style.display = 'block';

        zoneTitle.style.display = 'none';
        // scrollBack.style.display = 'none';
        //zoneHeading.innerHTML = 
        ResetHtmlCityInfoScene();

        currentItem = 0;

        updateLeftRightArrows();

        welcomeToZone();
        languageChangeRefrash();

        rotateDiv.style.top = '70%';
        rotateDiv.style.left = '20%';
        //playAudio("./sounds/Items.mp3");
      }
    }
  }
  
  if(transitionParams.transition===0 && !isAnimatingItemInfo && isDragging)
  {
     var itemToRotate = ((currentZoneSelected-1) * itemsPerZone) + currentItem;
    // items3DModels[itemToRotate].y = items3DModelsPos[itemToRotate].y;
    // items3DModels[itemToRotate].rotation.y = 0;
    liftHero(itemToRotate, 0);
    resetRotation(itemToRotate);
  }

  isDragging = false;
  isMouseDown = false;
}

function liftHero(number, amount)
{
  switch (number) {
      case 0:
        TweenMax.to(h1.position, 0.3, {y:amount});
      break;
      case 1:
        TweenMax.to(h2.position, 0.3, {y:(amount+1)});
      break;
      case 2:
        TweenMax.to(h3.position, 0.3, {y:amount+0.5});
      break;
      case 3:
        TweenMax.to(h4.position, 0.3, {y:amount+0.25});
      break;
      case 4:
        TweenMax.to(h5.position, 0.3, {y:amount});
      break;
      case 5:
        TweenMax.to(h6.position, 0.3, {y:amount+0.30});
      break;
      case 6:
        TweenMax.to(h7.position, 0.3, {y:amount});
      break;
      case 7:
        TweenMax.to(h8.position, 0.3, {y:amount});
      break;
      case 8:
        TweenMax.to(h9.position, 0.3, {y:amount});
      break;
  
    default:
      break;
  }
}

function rotateHero(number, amount)
{
  switch (number) {
      case 0:
        h1.quaternion.multiplyQuaternions(amount, h1.quaternion);
      break;
      case 1:
        h2.quaternion.multiplyQuaternions(amount, h2.quaternion);
      break;
      case 2:
        h3.quaternion.multiplyQuaternions(amount, h3.quaternion);
      break;
      case 3:
        h4.quaternion.multiplyQuaternions(amount, h4.quaternion);
      break;
      case 4:
        h5.quaternion.multiplyQuaternions(amount, h5.quaternion);
      break;
      case 5:
        h6.quaternion.multiplyQuaternions(amount, h6.quaternion);
      break;
      case 6:
        h7.quaternion.multiplyQuaternions(amount, h7.quaternion);
      break;
      case 7:
        h8.quaternion.multiplyQuaternions(amount, h8.quaternion);
      break;
      case 8:
        h9.quaternion.multiplyQuaternions(amount, h9.quaternion);
      break;
    default:
      break;
  }
}

function resetRotation(number)
{
  switch (number) {
      case 0:
        TweenMax.to(h1.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 1:
        TweenMax.to(h2.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 2:
        TweenMax.to(h3.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 3:
        TweenMax.to(h4.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 4:
        TweenMax.to(h5.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 5:
        TweenMax.to(h6.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 6:
        TweenMax.to(h7.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 7:
        TweenMax.to(h8.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
      case 8:
        TweenMax.to(h9.rotation, 0.3, {y:0});//, onComplete:()=>{h1.updateMatrix();}});
      break;
  
    default:
      break;
  }
}

function updateLeftRightArrows()
{
  var buttonL, buttonR;
  buttonL = document.getElementById("leftButton");
  buttonR = document.getElementById("rightButton");

  if(currentItem === 0)
  {
    buttonL.style.display = 'none'; 
    buttonR.style.display = 'block';
  }
  else if (currentItem === 2)
  {
    buttonL.style.display = 'block'; 
    buttonR.style.display = 'none';
  }
  else
  {
    buttonL.style.display = 'block'; 
    buttonR.style.display = 'block';
  }
  
}

function onDocumentTouchMove(event) 
{
  if(event.touches.length === 1){
  mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.touches[0].clientY / window.innerHeight) * 2 + 1;

  if(isTouchDragging)
  {
    var rect = event.target.getBoundingClientRect();
    var eventOffSetX = event.targetTouches[0].pageX - rect.left;
    var eventOffSetY = event.targetTouches[0].pageY - rect.top;

    var deltaMove = 
    {
      x: eventOffSetX-previousMousePosition.x,
      y: eventOffSetY-previousMousePosition.y
    };

    if(isTouchDragging && appState===1 && transitionParams.transition===1) 
    {
      var deltaRotationQuaternion = new THREE.Quaternion()
          .setFromEuler(new THREE.Euler(
              0,
              (deltaMove.x * 0.2 * 0.0174533),
              0,
              'XYZ'
          ));

      fCity.quaternion.multiplyQuaternions(deltaRotationQuaternion, fCity.quaternion);

      // if(fCity.rotation.y < MathUtils.degToRad(65) && fCity.rotation.y > MathUtils.degToRad(-25))
      // {
      //   //MathUtils.clamp(deltaRotationQuaternion.yaw, MathUtils.degToRad(-45), MathUtils.degToRad(45))
      //   fCity.quaternion.multiplyQuaternions(deltaRotationQuaternion, fCity.quaternion);
      //   //fCity.rotation.y += MathUtils.degToRad(deltaMove.x);
      // }
      // //else
      // //{
      //   if(fCity.rotation.y <= MathUtils.degToRad(-25))
      //     fCity.rotation.y = MathUtils.degToRad(-24.99);
      //   else if(fCity.rotation.y >= MathUtils.degToRad(65))
      //     fCity.rotation.y = MathUtils.degToRad(64.99);
      //}
      
    }

    // if(transitionParams.transition===0 && !isAnimatingItemInfo)
    // {
    //   //console.log(mouse);
    //   var itemToShow = ((currentZoneSelected-1) * itemsPerZone) + currentItem;//(numberOfZones*itemsPerZone) 

    //   TweenMax.to(sceneCityInfoCamera[0].position, 0.3, {x:(itemsCameraPos[itemToShow].x + (mouse.x)), y:(itemsCameraPos[itemToShow].y + (mouse.y)), z:itemsCameraPos[itemToShow].z, ease:"none"});
    //   //TweenMax.to(sceneCityInfoCamera[0].rotation, 0.3, {y:THREE.MathUtils.degToRad(itemsCameraRot[itemToShow] + (mouse.x * 10)), ease:"none"});

    // }

    if(transitionParams.transition===0 && !isAnimatingItemInfo && isTouchDragging)
    {
      var deltaRotation = new THREE.Quaternion()
          .setFromEuler(new THREE.Euler(
              0,
              (deltaMove.x * 0.5 * 0.0174533),
              0,
              'XYZ'
          ));
  
      var itemToRotate = ((currentZoneSelected-1) * itemsPerZone) + currentItem;
      //items3DModels[itemToRotate].position.y = items3DModelsPos[itemToRotate].y + 10;
      //items3DModels[itemToRotate].quaternion.multiplyQuaternions(deltaRotation, items3DModels[itemToRotate].quaternion);
      //console.log(items3DModels[itemToRotate].name);
      liftHero(itemToRotate, 1);
      rotateHero(itemToRotate, deltaRotation);
    }

    previousMousePosition = {x: eventOffSetX, y: eventOffSetY};
  }
  }
}

var whichZoneFoundPrev = "";

function onDocumentTouchEnd(event) 
{
  if(event.touches.length === 0)
  {
    isTouchDragging = false;
  }

  if(transitionParams.transition===0 && !isAnimatingItemInfo && event.touches.length === 0)
  {
     var itemToRotate = ((currentZoneSelected-1) * itemsPerZone) + currentItem;
    // items3DModels[itemToRotate].y = items3DModelsPos[itemToRotate].y;
    // items3DModels[itemToRotate].rotation.y = 0;
    liftHero(itemToRotate, 0);
    resetRotation(itemToRotate);
  }
}

function onDocumentTouchStart(event) 
{
  if(event.touches.length === 1){

    isTouchDragging = true;
    

    if(transitionParams.transition===1 || transitionParams.transition===0)
    {
      var rect = event.target.getBoundingClientRect();
      var eventOffSetX = event.targetTouches[0].pageX - rect.left;
      var eventOffSetY = event.targetTouches[0].pageY - rect.top;
      previousMousePosition = {x: eventOffSetX, y: eventOffSetY};
    }

    mouse.x = (event.touches[0].clientX/ window.innerWidth) * 2 - 1;
    mouse.y = -(event.touches[0].clientY / window.innerHeight) * 2 + 1;

    //console.log(mouse);
    checkForZoneElements(cScene, cCamera, mouse);

    //console.log(whichZoneFound);
    if(isCityLoaded && transitionParams.transition===1 && whichZoneFoundPrev === whichZoneFound)
    {
      if(whichZoneFound==="z1" || whichZoneFound==="z2" || whichZoneFound==="z3")
      {
        whichZoneFound = "";
        if(transitionParams.transition===1)
        {
          transitionParams.animateTransition = true;
          //var xBody = document.getElementsByTagName("BODY")[0];
          bodyElement.style.overflowY = 'hidden';
          disableBodyScroll(bodyElement);

          var xBody = document.getElementById("overlay");
          xBody.style.display = 'block';

          //xBody = document.getElementById("itemsInfo");
        
          zonePanel.style.display = 'block';
          zoneHeading.style.display = 'block';
          //xBody.style.display = 'block';

          zoneTitle.style.display = 'none';
          // scrollBack.style.display = 'none';
          //zoneHeading.innerHTML = 
          ResetHtmlCityInfoScene();

          currentItem = 0;

          updateLeftRightArrows();

          welcomeToZone();
          languageChangeRefrash();
          rotateDiv.style.top = '70%';
          rotateDiv.style.left = '20%';
          //playAudio("./sounds/Items.mp3");
        }
      }

      // if(whichZoneFound==="z1" || whichZoneFound==="z2" || whichZoneFound==="z3")
      // {
      //   //whichZoneFound = "";
      //   if(transitionParams.transition===1)
      //   {
      //     transitionParams.animateTransition = true;
      //     var xBody = document.getElementsByTagName("BODY")[0];
      //     xBody.style.overflowY = 'hidden';

      //     xBody = document.getElementById("overlay");
      //     xBody.style.display = 'block';

      //     zoneTitle.style.display = 'none';

      //     currentItem = 0;
      //     welcomeToZone();
      //   }
      // }
    }
    whichZoneFoundPrev = whichZoneFound;

  }


}



function onWindowResize() 
{
  //console.log("Resize");

  if(isCityLoaded && isCityInfoLoaded){
    sceneCityCamera[0].aspect = window.innerWidth / window.innerHeight;
    console.log(sceneCityCamera[0].aspect);

    if(sceneCityCamera[0].aspect < 1.25)
    {
      aspectTag.style.display = 'block';
    }
    else
    {
      aspectTag.style.display = 'none';
    }

    sceneCityCamera[0].updateProjectionMatrix();

    sceneCityInfoCamera[0].aspect = window.innerWidth / window.innerHeight;
    sceneCityInfoCamera[0].updateProjectionMatrix();

  }
  renderer.setSize( window.innerWidth, window.innerHeight );

  // if(isReachedCity)
  //   {
  //     window.scroll(0,document.body.scrollHeight);
  //   }
  //enableBodyScroll(bodyElement);

  isWindowResized = true;

}

var fCity = new Object3D();
var appState = 0;
//var mountainSprite;

// var cultureTextAR;
// var cultureTextEN;

// var lifestyleTextAR;
// var lifestyleTextEN;

// var economyTextAR;
// var economyTextEN;


gsap.registerPlugin(ScrollTrigger);
var cloudSpriteMap1;
var cloudSpriteMap2;

function setupAttributes( geometry ) {

  var vectors = [
    new THREE.Vector3( 1, 0, 0 ),
    new THREE.Vector3( 0, 1, 0 ),
    new THREE.Vector3( 0, 0, 1 )
  ];

  var position = geometry.attributes.position;
  var centers = new Float32Array( position.count * 3 );

  for ( var i = 0, l = position.count; i < l; i ++ ) {

    vectors[ i % 3 ].toArray( centers, i * 3 );

  }

  geometry.setAttribute( 'center', new THREE.BufferAttribute( centers, 3 ) );

}

//var backgroundPlane;
var fullTimeline;
var pinZ1, pinZ2, pinZ3;

function loadCity(cityScene, cityCamera)
{
  //console.log(cityScene.children);

  appState = 0;
  var mountain = null;
  var cityPos = new Vector3(0, 3200, 0);
  
  cityScene.fog = new THREE.FogExp2(0xa0a0a0, 0.001);
  //cityScene.background = new THREE.Color( 0x27465d );
  cityScene.background = new THREE.Color( 0x00000000 );

  var light = new THREE.AmbientLight( 0x404040 );
  cityScene.add( light );

  var directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
  cityScene.add( directionalLight );

  light = new THREE.DirectionalLight( 0xffffff, 0.5 );
	light.position.set( 0, 200, 100 );
	light.castShadow = true;
	light.shadow.camera.top = 180;
	light.shadow.camera.bottom = - 100;
	light.shadow.camera.left = - 120;
	light.shadow.camera.right = 120;
  cityScene.add( light );

  var manager = new THREE.LoadingManager();
  manager.onStart = function ( url, itemsLoaded, itemsTotal ) 
  {
    console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
  };

  manager.onLoad = function () 
  {
    console.log( 'Loading complete!'); 
    
    fCity.rotation.y = MathUtils.degToRad(20);
    cityScene.add(fCity);

    fullTimeline = new gsap.timeline({
      scrollTrigger:{start:"5%", end:"80%", scrub:1, scroller: document.body}//, markers: true}
      });

    
    fullTimeline.to("#imgMountain",  1, {opacity:0, ease:"none"})
    .to("#startButton", 0.3, {opacity:0, ease:"none"},'-=1')
    .to(mountain.children[0].material, 1, {opacity:1, ease:"none"},'-=1')
    .to(mountain.children[0].children[0].material, 1, {opacity:1, ease:"none"},'-=1')
    .to(cityCamera.position, 1, {y:150, z:100, ease:"none"})
    .to(cityCamera.position, 2, {y:1250, z:100, ease:"none"})
    .to(cityCamera.position, 2, {y:2250, z:300, ease:"none"})
    .to(cityCamera.position, 1,  {y:3250, z:450, ease:"none", onStart:appStateChangeTo0})
    .to(cityCamera.rotation, 1, {x:0, ease:"none"}, '-=1')
    .to(cityCamera.position, 1, {y:3300, z:300, ease:"none", onStart:appStateChangeTo0, onComplete:appStateChangeTo1})
    .to(cityCamera.rotation, 1, {x:(-30 * 0.0174533), onStart:appStateChangeTo0, ease:"none"}, '-=1')
    .to("#scrollDiv", 0.3, {opacity:0, ease:"none"}, '+=1');

    TweenMax.to(pinZ1.position, 3, {y:3265, repeatDelay:0.1, repeat:-1,  yoyo:true, ease:Elastic.easeInOut});
    TweenMax.to(pinZ2.position, 3, {y:3265, delay:2, repeatDelay:0.1, repeat:-1,  yoyo:true, ease:Elastic.easeInOut});
    TweenMax.to(pinZ3.position, 3, {y:3265, delay: 1, repeatDelay:0.1, repeat:-1,  yoyo:true, ease:Elastic.easeInOut});

    
    window.scrollTo(0,0);
    isCityLoaded = true;
    
    sceneCityCamera.push(cityCamera);

    //createParticleSystem(cityScene, manager);
    createCloudSystem(cityScene, manager);

    if((window.innerWidth / window.innerHeight) < 1.25)
    {
      aspectTag.style.display = 'block';
    } 

    loadingTag.style.display = 'none';

    //playAudio("./sounds/Loop1_StartAmbient.mp3");

    //pinZ1.lookAt(sceneCityCamera[0].position);
    //sound.play();
  };

  manager.onProgress = function ( url, itemsLoaded, itemsTotal ) 
  {
    console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
  };

  manager.onError = function ( url ) 
  {
    console.log( 'There was an error loading ' + url );
  };

  // var listener = new THREE.AudioListener();
  // cityCamera.add( listener );

  // create a global audio source
  // var sound = new THREE.Audio( listener );

  // load a sound and set it as the Audio object's buffer
  // var audioLoader = new THREE.AudioLoader();
  // audioLoader.load( './sounds/bg2.ogg', function( buffer ) {
  //   console.log("Music loaded");
  //   sound.setBuffer( buffer );
  //   sound.setLoop( true );
  //   sound.setVolume( 0.5 );
  //   sound.play();
  // });

  //loadZoneNames(cityScene, manager);

  cloudSpriteMap1 = new THREE.TextureLoader(manager).load( "./assets/cloud.png" );
  cloudSpriteMap2 = new THREE.TextureLoader(manager).load( "./assets/mrcloud.png" );

  //cultureTextAR.scale.set(200,50,1);
  //cultureText.position.set(-20,3275,150);
  //cultureText.position.set(-120,3250,30);


  // var map = new THREE.TextureLoader(manager).load( "./assets/pin.png" );
  // var materialimg = new THREE.SpriteMaterial( { map: map, color: 0xffffff, transparent: true, depthWrite:false} );

  // pinZ1 = new THREE.Sprite( materialimg );
  // pinZ1.scale.set(14.35,22.0,1);
  // pinZ1.position.set(-20,3250,150);
  // pinZ1.name = "zone1";
  // pinZ1.lookAt(cityCamera.position);

  // map = new THREE.TextureLoader(manager).load( "./assets/HeritageEN.png" );
  // materialimg = new THREE.SpriteMaterial( { map: map, color: 0xffffff, transparent: true, depthWrite:false} );

  // cultureTextEN = new THREE.Sprite( materialimg );
  // cultureTextEN.scale.set(200,50,1);
  // cultureTextEN.position.set(-20,3275,150);
  // cultureTextEN.lookAt(cityCamera.position);

  /////// life style

  // map = new THREE.TextureLoader(manager).load( "./assets/QualityOfLifeAR.png" );
  // materialimg = new THREE.SpriteMaterial( { map: map, color: 0xffffff, transparent: true, depthWrite:false} );

  // lifestyleTextAR = new THREE.Sprite( materialimg );
  // lifestyleTextAR.scale.set(200,50,1);
  // lifestyleTextAR.position.set(-120,3250,30);
  // lifestyleTextAR.lookAt(cityCamera.position);

  // map = new THREE.TextureLoader(manager).load( "./assets/QualityOfLifeEN.png" );
  // materialimg = new THREE.SpriteMaterial( { map: map, color: 0xffffff, transparent: true, depthWrite:false} );

  // lifestyleTextEN = new THREE.Sprite( materialimg );
  // lifestyleTextEN.scale.set(200,50,1);
  // lifestyleTextEN.position.set(-120,3250,30);
  // lifestyleTextEN.lookAt(cityCamera.position);

  ////// economy 

  // map = new THREE.TextureLoader(manager).load( "./assets/EconomyAR.png" );
  // materialimg = new THREE.SpriteMaterial( { map: map, color: 0xffffff, transparent: true, depthWrite:false} );

  // economyTextAR = new THREE.Sprite( materialimg );
  // economyTextAR.scale.set(200,50,1);
  // economyTextAR.position.set(-100,3275,-100);
  // economyTextAR.lookAt(cityCamera.position);

  // map = new THREE.TextureLoader(manager).load( "./assets/EconomyEN.png" );
  // materialimg = new THREE.SpriteMaterial( { map: map, color: 0xffffff, transparent: true, depthWrite:false} );

  // economyTextEN = new THREE.Sprite( materialimg );
  // economyTextEN.scale.set(200,50,1);
  // economyTextEN.position.set(-100,3275,-100);
  // economyTextEN.lookAt(cityCamera.position);

  /////////////
  
  var loader = new FBXLoader(manager);
  loader.load('./models/Mountain.fbx', function ( object ) 
  {
    mountain = object.clone();

    mountain.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: true});
        //child.material = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: false, wireframe:true, side: THREE.FrontSide, blending: THREE.AdditiveBlending});
        //child.material.opacity = 0.1;

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
        var wireframeMaterial = new THREE.LineBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
        //material.linewidth = 0.5;
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);

        // child.geometry.deleteAttribute( 'normal' );
				// child.geometry.deleteAttribute( 'uv' );

				// setupAttributes( child.geometry );

				// var mesh2 = new THREE.Mesh( child.geometry, wireframeMaterial );
				// mesh2.position.set( 15, -45, 0 );
        // cityScene.add( mesh2 );
        // mesh2.scale.multiplyScalar(5); 
      }
      
    } );

      mountain.position.x = 15;
      mountain.position.y = -45;
      mountain.position.z = 0;

      //console.log(mountain);

      mountain.scale.multiplyScalar(.35); 

      mountain.name = "mtn";
      mountain.children[0].material.opacity = 0;
      mountain.children[0].children[0].material.opacity = 0;
      cityScene.add( mountain );
  } );

  // var geometry = new THREE.PlaneBufferGeometry(3900, 2500, 100, 100, 1, true);
  // var material = new THREE.ShaderMaterial({
  // uniforms: {
  //   color1: {
  //     value: new THREE.Color(0xFED631)
  //   },
  //   color2: {
  //     value: new THREE.Color(0xF3843C)
  //   },
  //   color3: {
  //     value: new THREE.Color(0x03007C)
  //   }
  // },
  // vertexShader: `
  //   varying vec2 vUv;

  //   void main() {
  //     vUv = uv;
  //     gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
  //   }
  // `,
  // fragmentShader: `
  //   uniform vec3 color1;
  //   uniform vec3 color2;
  //   uniform vec3 color3;

  //   varying vec2 vUv;
    
  //   void main() {
  //     gl_FragColor = vec4(mix(color2, color3, vUv.y), 1.0);
  //   }
  // `,
  // wireframe: false
  // });
  // //gl_FragColor = vec4(mix(color2, color3, vUv.y), 1.0);
  // //vec4(mix(mix(color1, color2, vUv.y), mix(color2, color3, vUv.y), vUv.y), 1.0);
  // //gl_FragColor = vec4(mix(mix(color1, color2, vUv.y * 0.5), mix(color2, color3, vUv.y * 0.5), vUv.y), 1.0);

  // backgroundPlane = new THREE.Mesh(geometry, material);
  // backgroundPlane.position.x = 0;
  // backgroundPlane.position.y = 0;
  // backgroundPlane.position.z = -500;
  // cityScene.add(backgroundPlane);

  loader.load('./models/pin.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshLambertMaterial({color: 0xf37021});
      }
    } );

    object.position.x = -105;
    object.position.y = 3260;
    object.position.z = 170;
    object.scale.multiplyScalar(.007); 

    pinZ1 = object.clone();
    pinZ1.name="zone1";

    fCity.attach(pinZ1);
  } );

  loader.load('./models/pin.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshLambertMaterial({color: 0xf37021});
      }
    } );

    object.position.x = -95;
    object.position.y = 3260;
    object.position.z = -110;
    object.scale.multiplyScalar(.007); 

    pinZ2 = object.clone();
    pinZ2.name="zone2";

    fCity.attach(pinZ2);
  } );

  loader.load('./models/pin.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshLambertMaterial({color: 0xf37021});
      }
    } );

    object.position.x = 50;
    object.position.y = 3260;
    object.position.z = -15;
    object.scale.multiplyScalar(.007); 

    pinZ3 = object.clone();
    pinZ3.name="zone3";

    fCity.attach(pinZ3);
  } );

  loader.load('./models/CityRock.fbx', function ( object ) {

    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y;
    object.position.z = cityPos.z;
    
    object.scale.multiplyScalar(.4); 
  
    var obj = object.clone();
    fCity.attach(obj);
  } );

  loader.load('./models/CityBase.fbx', function ( object ) {

    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshLambertMaterial({color: 0x161616});
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y;
    object.position.z = cityPos.z;

    object.scale.multiplyScalar(.4); 
    
    //baseZone1 = object.clone();
    var obj = object.clone();
    fCity.attach(obj);
  } );

  // loader.load('./models/BaseZone2.fbx', function ( object ) {

  //   object.traverse( function ( child ) {            
  //     if ( child.isMesh ) {                
  //       child.castShadow = true;
  //       child.receiveShadow = true;
  //       child.material = new THREE.MeshLambertMaterial({color: 0x262626});
  //     }
      
  //   } );

  //   object.position.x = cityPos.x;
  //   object.position.y = cityPos.y;
  //   object.position.z = cityPos.z;

  //   object.scale.multiplyScalar(.4); 
    
  //   baseZone2 = object.clone();
  //   fCity.attach(baseZone2);
  // } );

  // loader.load('./models/BaseZone3.fbx', function ( object ) {

  //   object.traverse( function ( child ) {            
  //     if ( child.isMesh ) {                
  //       child.castShadow = true;
  //       child.receiveShadow = true;
  //       child.material = new THREE.MeshLambertMaterial({color: 0x262626});
  //     }
      
  //   } );

  //   object.position.x = cityPos.x;
  //   object.position.y = cityPos.y;
  //   object.position.z = cityPos.z;

  //   object.scale.multiplyScalar(.4); 
    
  //   baseZone3 = object.clone();
  //   fCity.attach(baseZone3);
  // } );

  loader.load('./models/Sea.fbx', function ( object ) {

    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;//2e528e    ///0c8da4
        child.material = new THREE.MeshLambertMaterial({color: 0x202020});// 0x174463});
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y;
    object.position.z = cityPos.z;

    object.scale.multiplyScalar(.4); 

    var obj = object.clone();
    fCity.attach(obj);
  } );

  // loader.load('./models/Greens.fbx', function ( object ) {

  //   object.traverse( function ( child ) {            
  //     if ( child.isMesh ) {                
  //       child.castShadow = true;
  //       child.receiveShadow = true;//2e528e    ///0c8da4
  //       child.material = new THREE.MeshLambertMaterial({color: 0x0b4d24});
  //     }
      
  //   } );

  //   object.position.x = cityPos.x;
  //   object.position.y = cityPos.y;
  //   object.position.z = cityPos.z;

  //   object.scale.multiplyScalar(.4); 

  //   var obj = object.clone();
  //   fCity.attach(obj);
  // } );

  loader.load('./models/Roads.fbx', function ( object ) {

    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true; //535353
        child.material = new THREE.MeshLambertMaterial({color: 0x080808});
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y + 1;
    object.position.z = cityPos.z;

    object.scale.multiplyScalar(.4); 
    
    var obj = object.clone();
  
    fCity.attach(obj);
  } );

  loader.load('./models/SurroundBuildings.fbx', function ( object ) {

    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        //child.castShadow = true;
        //child.receiveShadow = true;
        child.material = new THREE.MeshLambertMaterial({color: 0x000000});//, transparent: true, wireframe:true});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0x404040, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y;
    object.position.z = cityPos.z;

    object.scale.multiplyScalar(.4); 
    
    var obj = object.clone();
    
    fCity.attach(obj);
  } );

  loader.load('./models/Zone01.fbx', function ( object ) {
    // Greens // Zone01
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        //child.castShadow = true;
        //child.receiveShadow = true;0xFED631
        //child.material = new THREE.MeshLambertMaterial({color: 0xffffff, transparent: true, wireframe:true});
        child.material = new THREE.MeshLambertMaterial({color: 0xFED631, transparent: false, wireframe:true});
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y + 1;
    object.position.z = cityPos.z +1;

    //position.set(-20,3250,150);

    object.scale.multiplyScalar(.4); 
    
    zone1 = object.clone();
    //zone1.attach()
    //floatingCity.push(obj);
    zone1.name = "zone1";
    //baseZone1.name = "zone1";
    //zone1.attach(pinZ1);

    fCity.attach(zone1);
    //fCity.rotation.y = 1;
    //scene.add(fCity);

    //scene.add( object );
  } );

  loader.load('./models/Zone02.fbx', function ( object ) {

    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        //child.castShadow = true;
        //child.receiveShadow = true;
        //child.material = new THREE.MeshLambertMaterial({color: 0xffffff, transparent: true, wireframe:true});
        child.material = new THREE.MeshLambertMaterial({color: 0xF3843C, transparent: false, wireframe:true});
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y;
    object.position.z = cityPos.z;

    object.scale.multiplyScalar(.4); 
    
    zone2 = object.clone();
    zone2.name = "zone2";
    //baseZone3.name = "zone2";
    //zone2.attach(baseZone3);
    fCity.attach(zone2);
  } );

  loader.load('./models/Zone03.fbx', function ( object ) { 

    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        //child.castShadow = true;
        //child.receiveShadow = true;
        //child.material = new THREE.MeshLambertMaterial({color: 0xffffff, transparent: true, wireframe:true});
        child.material = new THREE.MeshLambertMaterial({color: 0x03007C, transparent: false, wireframe:true});
      }
      
    } );

    object.position.x = cityPos.x;
    object.position.y = cityPos.y;
    object.position.z = cityPos.z;

    object.scale.multiplyScalar(.4); 
  
    zone3 = object.clone();
    zone3.name = "zone3";
    //baseZone2.name = "zone3";
    //zone3.attach(baseZone2);
    fCity.attach(zone3);

    // fCity.attach(cultureTextAR);
    // fCity.attach(lifestyleTextAR);
    // fCity.attach(economyTextAR);

    //fCity.attach(pinZ1);
    // fCity.attach(lifestyleTextEN);
    // fCity.attach(economyTextEN);

    // cultureTextAR.visible = false;
    // lifestyleTextAR.visible = false;
    // economyTextAR.visible = false;

    // cultureTextEN.visible = false;
    // lifestyleTextEN.visible = false;
    // economyTextEN.visible = false;
  } );
  createParticleSystem(cityScene, manager);
  //createCloudSystem(cityScene, manager);

}
// Culture  Quality of Life  Economy

function loadZoneNames(cityScene, manager)
{
  var loader = new THREE.FontLoader(manager);

  loader.load( 'fonts/helvetiker_regular.typeface.json', function ( font ) {

    var fGeometry = new THREE.TextGeometry( 'Culture', {
      font: font,
      size: 100,
      height: 5,
      curveSegments: 12,
      bevelEnabled: true,
      bevelThickness: 10,
      bevelSize: 8,
      bevelOffset: 0,
      bevelSegments: 5
    } );

    fGeometry = new THREE.BufferGeometry().fromGeometry( fGeometry );

		var textMesh1 = new THREE.Mesh( fGeometry, new THREE.MeshPhongMaterial( { color: 0xF7941D} ) );

		textMesh1.position.x = -10;
		textMesh1.position.y = 3250;
		textMesh1.position.z = 180;

    textMesh1.scale.multiplyScalar(0.1);

		textMesh1.rotation.x = 0;
		textMesh1.rotation.y = THREE.MathUtils.degToRad(180);

    //fCity.attach(textMesh1);
    //cityScene.add(textMesh1);

  } );
}

function appStateChangeTo0()
{
  appState=0;
  fCity.rotation.y = MathUtils.degToRad(20);
}

var isReachedCity = false;


function appStateChangeTo1()
{
  appState=1;

  if(!isReachedCity)
  {
    isReachedCity = true;
    // scrollBack.style.display = 'block';
    disableBodyScroll(bodyElement);

    rotateDiv.style.display = 'block';
    rotateDiv.style.top = '80%';
    rotateDiv.style.left = '40%';
    //playAudio("./sounds/City.mp3");
  }
}

function createParticleSystem(cityScene, manager)
{
  var materials = [], parameters;
  
  var geometry = new THREE.BufferGeometry();
  var vertices = [];
  var particles;

  var textureLoader = new THREE.TextureLoader(manager);
  textureLoader.crossOrigin = '';
   var sprite1 = textureLoader.load( './assets/spark.png' );
  // var sprite2 = textureLoader.load( './assets/snowflake2.png' );
  // var sprite3 = textureLoader.load( './assets/snowflake3.png' );
  // var sprite4 = textureLoader.load( './assets/snowflake4.png' );
  // var sprite5 = textureLoader.load( './assets/snowflake5.png' );
  var i = 0;

  for (i = 0; i < 20000; i ++ ) {

    var x = Math.random() * 10000 - 5000;
    var y = Math.random() * 10000 - 5000;
    var z = 1500 + ((Math.random() * 2000) - 1800);

    vertices.push( x, y, z );

  }

  //var geometry = new THREE.BufferGeometry().setFromPoints(vertices);
  //geometry.setDrawRange(0, 0);

  geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );

  parameters = [
    [[ 1.0, 0.2, 0.5 ], sprite1, 10 ],
    [[ 0.95, 0.1, 0.5 ], sprite1, 5 ],
    [[ 0.90, 0.05, 0.5 ], sprite1, 7 ],
    [[ 0.85, 0, 0.5 ], sprite1, 8 ],
    [[ 0.80, 0, 0.5 ], sprite1, 9 ]
  ];

  for (i = 0; i < parameters.length; i ++ ) {

    var color = parameters[ i ][ 0 ];
    var sprite = parameters[ i ][ 1 ];
    var size = parameters[ i ][ 2 ];
    
    //materials[ i ] = new THREE.PointsMaterial( { color: 0xffffff, size: 10, map: sprite, blending: THREE.AdditiveBlending, transparent: true} );
    materials[ i ] = new THREE.PointsMaterial( { color: 0xffffff, size: size, map: sprite, blending: THREE.AdditiveBlending, depthTest: false, transparent: true, fog: false } );
    materials[ i ].color.setHSL( color[ 0 ], color[ 1 ], color[ 2 ] );

    particles = new THREE.Points( geometry, materials[ i ] );

    particles.rotation.x = Math.random() * 6;
    particles.rotation.y = Math.random() * 6;
    particles.rotation.z = Math.random() * 6;

    cityScene.add( particles );
  }
}


function updateParticles(cityScene)
{
  var time = Date.now() * 0.000005;
  for ( var i = 0; i < cityScene.children.length; i ++ ) {
    var object = cityScene.children[ i ];

    if ( object instanceof THREE.Points ) {

      object.rotation.y = time * ( i < 4 ? i + 1 : - ( i + 1 ) );

    }
  }
}

var clouds = [];
var speeds = [];
var directions = [];
var speedFactor = 2;

function createCloudSystem(cityScene, manager)
{
  //var spriteMap1 = new THREE.TextureLoader(manager).load( "./assets/cloud.png" );
  //var spriteMap2 = new THREE.TextureLoader(manager).load( "./assets/mrcloud.png" );

  var spriteMaterial1 = new THREE.SpriteMaterial( { map: cloudSpriteMap1, transparent: true, depthWrite:false} );
  var spriteMaterial2 = new THREE.SpriteMaterial( { map: cloudSpriteMap2, transparent: true, depthWrite:false } );
	
	for ( var i = 0; i < 300; i ++ ) 
	{
		var scale = 350 + Math.random() * 200

    var spriteCloud;
    if(Math.random() < 0.5)
    {spriteCloud = new THREE.Sprite( spriteMaterial1 );}
    else
    {spriteCloud = new THREE.Sprite( spriteMaterial2 );}
    
    spriteCloud.scale.set(scale,scale,1);
	
		spriteCloud.position.x = Math.random() * 3000 - 1500
		spriteCloud.position.y = 900 + Math.random() * 2000;
		spriteCloud.position.z = (Math.random() * -500) - 300;

		spriteCloud.rotation.x = THREE.MathUtils.degToRad(Math.random() * 90);
		spriteCloud.rotation.y = 0;//THREE.MathUtils.degToRad(Math.random() * 90);
		spriteCloud.rotation.z = THREE.MathUtils.degToRad(Math.random() * 90);
    
    clouds.push(spriteCloud);
    speeds.push(Math.random() * speedFactor);

    if(Math.random() < 0.5)
      {directions.push(0);}
    else
      {directions.push(0)}

		cityScene.add( spriteCloud );
	}

  for ( var i = 0; i < 100; i ++ ) 
	{
		var scale = 500 + Math.random() * 200

    var spriteCloud;
    if(Math.random() < 0.5)
    {spriteCloud = new THREE.Sprite( spriteMaterial1 );}
    else
    {spriteCloud = new THREE.Sprite( spriteMaterial2 );}
    
    spriteCloud.scale.set(scale,scale,1);
	
		spriteCloud.position.x = Math.random() * 3000 - 1500
		spriteCloud.position.y = 2700 + Math.random() * 200;
		spriteCloud.position.z = Math.random() * 2500 - 1250;

		spriteCloud.rotation.x = Math.random() * 2 * Math.PI;
		spriteCloud.rotation.y = Math.random() * 2 * Math.PI;
		spriteCloud.rotation.z = Math.random() * 2 * Math.PI;
    
    clouds.push(spriteCloud);
    speeds.push(Math.random() * speedFactor);

    if(Math.random() < 0.5)
    {directions.push(0);}
    else
    {directions.push(0)}

		cityScene.add( spriteCloud );
  }
}

function updateCloudSystem()
{
  for(var c = 0; c < clouds.length; c++)
  {
    if(directions[c] === 0)
    {
      clouds[c].position.x -= speeds[c]
      if(clouds[c].position.x < (-1*((window.innerWidth/2) + (clouds[c].scale.x*2))) )
      {
        clouds[c].position.x = 1500;
        directions[c] = 0;
        speeds[c] = Math.random() * speedFactor;
      }
    }
    else
    {
      clouds[c].position.x += speeds[c]
      if(clouds[c].position.x > 1500)
      {
        directions[c] = 0;
        speeds[c] = Math.random();
      }
    }
  }
}

//---------------------------------------City END------------------------------------------------------


//---------------------------------------City Info------------------------------------------------------

function CityInfo() 
{
  this.clearColor = 0x00000;
  
  this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1000 );

  //sceneCameras.push(this.camera);
	//this.camera.position.z = 100;
	// Setup scene
	this.scene = new THREE.Scene();

  loadCityInfo(this.scene, this.camera);
 
	var renderTargetParameters = { minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter, format: THREE.RGBFormat, stencilBuffer: false };
	this.fbo = new THREE.WebGLRenderTarget( window.innerWidth, window.innerHeight, renderTargetParameters );
	this.render = function ( delta, rtt ) {
		
		renderer.setClearColor( this.clearColor);
		if ( rtt ) {
			renderer.setRenderTarget( this.fbo );
			renderer.clear();
			renderer.render( this.scene, this.camera );
		} else {
			renderer.setRenderTarget( null );
      renderer.render( this.scene, this.camera );
      
      if(zoneTitle.style.display === 'block')
      {      
        zoneTitle.style.display = 'none';
        zoneName.innerHTML = "";
      }
		}
	};
}

var isCityInfoLoaded = false;
var itemsCameraPos = [];
var itemsCameraRot = [];
//var items3DModels = [];
//var items3DModelsPos = [];
//var items3DModelsScale = [];
//var items3DModelsRot = [];
var currentItem = 0;
var h1, h2, h3, h4, h5, h6, h7, h8, h9;
//var cityInfoObject = [];

function loadCityInfo(cityInfoScene, cityInfoCamera)
{
  //cityInfoCameraRef = cityInfoCamera;

  //var size = 160;
  //var divisions = 90;

  // var gridHelper = new THREE.GridHelper( size, divisions );
  // gridHelper.colorGrid = 0xffffff;
  // cityInfoScene.add( gridHelper );

  //itemsCameraPos = [new Vector3(0,5,7), new Vector3(0,5,22), new Vector3(0,5,37)];
  //itemsCameraPos = new Array(3);

  var light = new THREE.AmbientLight( 0x404040 ); // soft white light
  cityInfoScene.add( light );

  var directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
  cityInfoScene.add( directionalLight );

  light = new THREE.DirectionalLight( 0xffffff, 0.5 );
	light.position.set( 0, 200, 100 );
	light.castShadow = true;
	light.shadow.camera.top = 180;
	light.shadow.camera.bottom = - 100;
	light.shadow.camera.left = - 120;
	light.shadow.camera.right = 120;
  cityInfoScene.add( light );
  
  /////// Middle
  //M
  //cityInfoCamera.position.set( 10, 5, 2);
  //cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-5);

  //F
  // cityInfoCamera.position.set( 8, 5, 110);
  // cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-10);

  //L
  // cityInfoCamera.position.set( 8, 5, -100);
  // cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-20);

  /////right
  //M
  // cityInfoCamera.position.set( 80, 3, 1);
  // cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-5);

  // //f
  cityInfoCamera.position.set( 80, 3, 105);
  cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-5);

  //  //L
  //  cityInfoCamera.position.set( 80, 3, -103);
  //  cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-10);

   /////Left
  //M
  // cityInfoCamera.position.set( -65, 3, -2);
  // cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-5);

  // cityInfoCamera.position.set( -70, 3, 107);
  // cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-5);

  // cityInfoCamera.position.set( -68, 3, -103);
  // cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-20);

  // //f
  // cityInfoCamera.position.set( -80, 3, 105);
  // cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-5);

  //  //L
  //  cityInfoCamera.position.set( -80, 3, -103);
  //  cityInfoCamera.rotation.x = THREE.MathUtils.degToRad(-10);

  //var posToLook = new Vector3(2,2,0);

  //cityInfoCamera.lookAt( posToLook );

  cityInfoScene.fog = new THREE.FogExp2(0x000000, 0.02);
  cityInfoScene.background = new THREE.Color( 0x00000000 );

  var lightCI = new THREE.AmbientLight( 0x404040 );
  cityInfoScene.add( lightCI );

  var directionalLightCI = new THREE.DirectionalLight( 0xffffff, 0.5 );
  cityInfoScene.add( directionalLightCI );

  light = new THREE.DirectionalLight( 0xffffff, 0.5 );
	light.position.set( 0, 200, 100 );
	light.castShadow = true;
	light.shadow.camera.top = 180;
	light.shadow.camera.bottom = - 100;
	light.shadow.camera.left = - 120;
	light.shadow.camera.right = 120;
  cityInfoScene.add( light );

  var manager = new THREE.LoadingManager();
  manager.onStart = function ( url, itemsLoaded, itemsTotal ) 
  {
    console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
  };

  manager.onLoad = function () 
  {
    console.log( 'Loading complete!'); 
    //cityInfoCamera.lookAt(new Vector3(0,0,0));

    itemsCameraPos.push(new Vector3(80, 3, 105));
    itemsCameraPos.push(new Vector3(80, 3, 1));
    itemsCameraPos.push(new Vector3(80, 3, -103));

    itemsCameraPos.push(new Vector3(8, 5, 110));
    itemsCameraPos.push(new Vector3(10, 5, 2));
    itemsCameraPos.push(new Vector3(8, 5, -100));

    itemsCameraPos.push(new Vector3(-70, 3, 107));
    itemsCameraPos.push(new Vector3(-65, 3, -2));
    itemsCameraPos.push(new Vector3(-68, 3, -103));
    
    itemsCameraRot.push(-5);
    itemsCameraRot.push(-5);
    itemsCameraRot.push(-10);

    itemsCameraRot.push(-10);
    itemsCameraRot.push(-5);
    itemsCameraRot.push(-20);

    itemsCameraRot.push(-5);
    itemsCameraRot.push(-5);
    itemsCameraRot.push(-20);

    sceneCityInfoCamera.push(cityInfoCamera);
    isCityInfoLoaded = true;
    //cityInfoObject.push(cityInfoCamera);
  };

  manager.onProgress = function ( url, itemsLoaded, itemsTotal ) 
  {
    console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
  };

  manager.onError = function ( url ) 
  {
    console.log( 'There was an error loading ' + url );
  };
  var loader = new FBXLoader(manager);
  
  loader.load('./models/terrain.fbx', function ( object ) {

    //var model = new Object3D();
    
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0x333333, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );

    object.position.x = 0;
    object.position.y = 0;
    object.position.z = 0;
    
    object.scale.multiplyScalar(.05); 
    //model = object.clone();
    //zoneOneModels.push(model);

    var obj = object.clone();
    cityInfoScene.add(obj);
  } );

  // loader.load('./models/herobuildings.fbx', function ( object ) {

  //   //var model = new Object3D();
    
  //   object.traverse( function ( child ) {            
  //     if ( child.isMesh ) {                
  //       child.castShadow = true;
  //       child.receiveShadow = true;
  //       child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

  //       var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
	// 	    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
	// 	    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
  //       child.add(wireframe);
  //     }
      
  //   } );
  //   object.position.x = 0;
  //   object.position.y = 0;
  //   object.position.z = 0;
    
  //   object.scale.multiplyScalar(.05); 
  //   //model = object.clone();
  //   //zoneOneModels.push(model);

  //   var obj = object.clone();
  //   cityInfoScene.add(obj);
  // } );

  loader.load('./models/heros/madiansaleh.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(75, 0, 95);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.06;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);

    h1 = object.clone();
    //items3DModels.push(obj);
    cityInfoScene.add(h1);
  } );

  loader.load('./models/heros/nassief.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(75, 1, -10);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.07;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);
    
    h2 = object.clone();
   
    cityInfoScene.add(h2);
  } );

  loader.load('./models/heros/Camelrock.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(75, 0.5, -112);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.08;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);
    
    h3 = object.clone();
    cityInfoScene.add(h3);
  } );


  ///////
  loader.load('./models/heros/itcc00.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(2, 0.25, 95);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.06;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);

    h4 = object.clone();
    cityInfoScene.add(h4);
  } );

  loader.load('./models/heros/future.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(5, 0, -10);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.05;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);
    
    h5 = object.clone();
    cityInfoScene.add(h5);
  } );

  loader.load('./models/heros/factory.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(3, 0.30, -112);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.05;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);
    
    h6 = object.clone();
    cityInfoScene.add(h6);
  } );
  /////////
  loader.load('./models/heros/MDlBeast.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(-75, 0, 95);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.05;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);

    h7 = object.clone();
    cityInfoScene.add(h7);
  } );

  loader.load('./models/heros/sport.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(-70, 0, -15);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.05;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);
    
    h8 = object.clone();
    cityInfoScene.add(h8);
  } );

  loader.load('./models/heros/medical.fbx', function ( object ) {
    object.traverse( function ( child ) {            
      if ( child.isMesh ) {                
        child.castShadow = true;
        child.receiveShadow = true;
        child.material = new THREE.MeshBasicMaterial({color: 0x000000, transparent: false, wireframe:false});

        var wireframeGeomtry = new THREE.WireframeGeometry( child.geometry );
		    var wireframeMaterial = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true, side: THREE.DoubleSide, blending: THREE.AdditiveBlending});
		    var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
        child.add(wireframe);
      }
      
    } );
    var pos = new Vector3(-71, 0, -110);
    object.position.x = pos.x;
    object.position.y = pos.y;
    object.position.z = pos.z;

    var scale = 0.05;
    //var rotation = 0;

    //items3DModelsPos.push(pos);
    //items3DModelsRot.push(rotation);
    //items3DModelsScale.push(scale);
   
    object.scale.multiplyScalar(scale); 
    //object.rotation.y = MathUtils.degToRad(rotation);
    
    h9 = object.clone();
    cityInfoScene.add(h9);
  } );
  //////
  // var geometry = new THREE.PlaneGeometry(2000, 2000, 20, 20);
  // var material = new THREE.MeshBasicMaterial( {color: 0x000000, side: THREE.DoubleSide} );
  // var plane = new THREE.Mesh( geometry, material );
  // plane.rotation.x = MathUtils.degToRad(-90);
  // plane.position.x = 0;
  // plane.position.y = -1;
  // plane.position.z = -100;

  // cityInfoScene.add( plane );

  // var geometry = new THREE.PlaneBufferGeometry(2000, 500, 100, 100, 1, true);
  // var material = new THREE.ShaderMaterial({
  // uniforms: {
  //   color1: {
  //     value: new THREE.Color(0xFED631)
  //   },
  //   color2: {
  //     value: new THREE.Color(0xF3843C)
  //   },
  //   color3: {
  //     value: new THREE.Color(0x03007C)
  //   }
  // },
  // vertexShader: `
  //   varying vec2 vUv;

  //   void main() {
  //     vUv = uv;
  //     gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
  //   }
  // `,
  // fragmentShader: `
  //   uniform vec3 color1;
  //   uniform vec3 color2;
  //   uniform vec3 color3;

  //   varying vec2 vUv;
    
  //   void main() {
  //     gl_FragColor = vec4(mix(color2, color3, vUv.y), 1.0);
  //   }
  // `,
  // wireframe: false
  // });
  // //gl_FragColor = vec4(mix(color2, color3, vUv.y), 1.0);
  // //vec4(mix(mix(color1, color2, vUv.y), mix(color2, color3, vUv.y), vUv.y), 1.0);
  // //gl_FragColor = vec4(mix(mix(color1, color2, vUv.y * 0.5), mix(color2, color3, vUv.y * 0.5), vUv.y), 1.0);

  // var mesh = new THREE.Mesh(geometry, material);
  // mesh.position.x = 0;
  // mesh.position.y = 0;
  // mesh.position.z = -250;
  // cityInfoScene.add(mesh);

  // loader.load('./models/z1/al farida.fbx', function ( object ) {

  //   var model = new Object3D();

  //   object.traverse( function ( child ) {            
  //     if ( child.isMesh ) {                
  //       child.castShadow = true;
  //       child.receiveShadow = true;
  //       child.material = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true});
  //     }
      
  //   } );

  //   object.position.x = 0;
  //   object.position.y = 0;
  //   object.position.z = -15;
    
  //   object.scale.multiplyScalar(.04); 
  //   model = object.clone();
  //   zoneOneModels.push(model);

  //   var obj = object.clone();
  //   cityInfoScene.add(obj);
  // } );

  // loader.load('./models/z1/nassief house.fbx', function ( object ) {

  //   var model = new Object3D();

  //   object.traverse( function ( child ) {            
  //     if ( child.isMesh ) {                
  //       child.castShadow = true;
  //       child.receiveShadow = true;
  //       child.material = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, wireframe:true});
  //     }
      
  //   } );

  //   object.position.x = 0;
  //   object.position.y = 0;
  //   object.position.z = -30;
    
  //   object.scale.multiplyScalar(.045); 
  //   model = object.clone();
  //   zoneOneModels.push(model);

  //   var obj = object.clone();
  //   cityInfoScene.add(obj);
  // } );
}

function welcomeToZone()
{
  var itemToShow = ((currentZoneSelected-1) * itemsPerZone) + currentItem;
  
  sceneCityInfoCamera[0].position.x = itemsCameraPos[itemToShow].x;
  sceneCityInfoCamera[0].position.y = itemsCameraPos[itemToShow].y;
  sceneCityInfoCamera[0].position.z = itemsCameraPos[itemToShow].z;

  sceneCityInfoCamera[0].rotation.x = THREE.MathUtils.degToRad(itemsCameraRot[itemToShow]);
}

function languageChangeRefrash()
{
  //if(transitionParams.transition===0)
  //{
    var xBody = document.getElementById("itemsHeading");
    if(languageSelected === 1)
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].headingEN;
      xBody.style.textAlign = 'left';
      xBody.style.fontFamily = 'formulaCondensed';
    }
    else
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].heading;
      xBody.style.textAlign = 'right';
      xBody.style.fontFamily = 'AlmaraiBold';
    }
    


    // if(languageSelected === 1)
    //   xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].headingEN;
    // else
    //   xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].heading;

    xBody = document.getElementById("itemsDetails");
    if(languageSelected === 1)
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].infoEN;
      xBody.style.textAlign = 'left';
      xBody.style.fontFamily = 'acuminVariable';
    }
    else
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].info;
      xBody.style.textAlign = 'right';
      xBody.style.fontFamily = 'AlmaraiLight';
    }

    if(languageSelected === 1)
    {
      zoneHeading.innerHTML = itemsInfoData[currentZoneSelected-1].zoneNameEN
      zoneHeading.style.textAlign = 'left';
      zoneHeading.style.fontFamily = 'formulaCondensed';
    }
    else
    {
      zoneHeading.innerHTML = itemsInfoData[currentZoneSelected-1].zoneNameAR;
      zoneHeading.style.textAlign = 'right';
      zoneHeading.style.fontFamily = 'AlmaraiBold';
    }

    if(languageSelected === 1)
    {
      zoneName.innerHTML = itemsInfoData[currentZoneSelected-1].zoneNameEN
      zoneHeading.style.textAlign = 'left';
      zoneName.style.fontFamily = 'formulaCondensed';
    }
    else
    {
      zoneName.innerHTML = itemsInfoData[currentZoneSelected-1].zoneNameAR;
      zoneHeading.style.textAlign = 'right';
      zoneName.style.fontFamily = 'AlmaraiBold';
    }

  //}
  
    // var split = new SplitText("#words", { type: "words, chars" });
    // var vh = window.innerHeight;
    // var vw = window.innerWidth;
    // TweenMax.staggerFrom(
    //   split.words,
    //   1.25,
    //   {
    //     cycle: {
    //       x: [-(vw / 2) - 100, 0, vw / 2 + 100, 0],
    //       y: [0, -vh / 2 - 100, 0, vh / 2 + 100]
    //     },
    //     ease:Back.easeOut
    //   },
    //   0.1
    // );

    // splitAndAnimate();
}

// var textAnim;
// var mySplitText;

// function splitAndAnimate() {
//   if(textAnim) {
//     textAnim.kill();
//   }
  
//   mySplitText = new SplitText("#itemsDetails", {type:"lines"});
//   var lines = mySplitText.lines; 

//   textAnim = gsap.timeline()
//   .from(lines, {duration: 0.8, opacity:0, scale:0, y:80, rotationX:180, transformOrigin:"0% 50% -50",  ease:"back", stagger: 0.1, onComplete:allDone});
// }

// function allDone() {
//   mySplitText.revert();
// }

//var numberOfZones = 3;
var itemsPerZone = 3;
var currentZoneSelected = 1;

function UpdateItemsDetails()
{
    var xBody = document.getElementById("itemsHeading");
    if(languageSelected === 1)
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].headingEN;
      xBody.style.textAlign = 'left';
    }
    else
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].heading;
      xBody.style.textAlign = 'right';
    }

    xBody = document.getElementById("itemsDetails");
    if(languageSelected === 1)
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].infoEN;
      xBody.style.textAlign = 'left';
    }
    else
    {
      xBody.innerHTML = itemsInfoData[currentZoneSelected-1].items[currentItem].info;
      xBody.style.textAlign = 'right';
    }

}
function onRightArrowClicked()
{
  //console.log(zoneOneModels);

  if(transitionParams.transition === 0 && currentZoneSelected > 0)
  {
    ResetHtmlCityInfoScene();
    if(!isAnimatingItemInfo)
    {
      if(currentItem<(itemsPerZone-1))
        currentItem++;
      
      updateLeftRightArrows();
      var itemToShow = ((currentZoneSelected-1) * itemsPerZone) + currentItem;//(numberOfZones*itemsPerZone) 
      TweenMax.to(sceneCityInfoCamera[0].position, 1, {x:itemsCameraPos[itemToShow].x, y:itemsCameraPos[itemToShow].y, z:itemsCameraPos[itemToShow].z, onComplete:itemsInfoCameraAnimFinished, ease:"none"});
      TweenMax.to(sceneCityInfoCamera[0].rotation, 1, {x:THREE.MathUtils.degToRad(itemsCameraRot[itemToShow]), ease:"none"});

      isAnimatingItemInfo = true;
    }

    UpdateItemsDetails();
    // else if(whichZoneFound==="z2")
    // {

    // }
    // else if(whichZoneFound==="z3")
    // {

    // }
    // currentItem++;
    // if(currentItem>=itemsCameraPos.length)
    //   currentItem = 0;

    // TweenMax.to(cityInfoObject[0].position, 1, {x:itemsCameraPos[currentItem].x, y:itemsCameraPos[currentItem].y, z:itemsCameraPos[currentItem].z, ease:"none"});
  }
}
var isAnimatingItemInfo = false;

function itemsInfoCameraAnimFinished()
{
  isAnimatingItemInfo = false;
}

function onLeftArrowClicked()
{
  if(transitionParams.transition === 0 && currentZoneSelected > 0)
  {
    ResetHtmlCityInfoScene();

    if(!isAnimatingItemInfo)
    {
      if(currentItem>0)
        currentItem--;

      updateLeftRightArrows();
      var itemToShow = ((currentZoneSelected-1) * itemsPerZone) + currentItem;//(numberOfZones*itemsPerZone) 

      TweenMax.to(sceneCityInfoCamera[0].position, 1, {x:itemsCameraPos[itemToShow].x, y:itemsCameraPos[itemToShow].y, z:itemsCameraPos[itemToShow].z, onComplete:itemsInfoCameraAnimFinished, ease:"none"});
      TweenMax.to(sceneCityInfoCamera[0].rotation, 1, {x:THREE.MathUtils.degToRad(itemsCameraRot[itemToShow]), ease:"none"});
      isAnimatingItemInfo = true;
    }

    UpdateItemsDetails();
  // if(transitionParams.transition===0)
  // {
  //   currentItem--;
  //   if(currentItem<0)
  //     currentItem = (itemsCameraPos.length-1);

  //   TweenMax.to(cityInfoObject[0].position, 1, {x:itemsCameraPos[currentItem].x, y:itemsCameraPos[currentItem].y, z:itemsCameraPos[currentItem].z, ease:"none"});
  // }
  }
}

//---------------------------------------City Info END------------------------------------------------------